var _g, _g2, _g3, _path, _path2, _g4, _path3, _path4, _path5, _path6, _g5, _g6, _g7, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _path16, _g8, _g9, _g10, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g11, _g12, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g13, _g14, _g15, _path43, _path44, _path45, _path46, _g16, _g17, _g18, _g19, _path47, _path48, _path49, _path50, _path51, _circle, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g20, _g21, _path61, _path62, _path63, _path64, _path65, _path66, _circle2, _path67, _path68, _path69, _path70, _circle3, _path71, _path72, _path73, _path74, _circle4, _path75, _path76, _path77, _g22, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _g23, _path88, _path89, _rect2, _path90, _path91, _path92, _path93, _path94, _path95, _g24, _g25, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _g26, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _g27, _rect3, _path120, _path121, _path122, _path123, _path124, _path125, _circle5, _path126, _path127, _path128, _path129, _path130, _g28, _g29, _g30, _g31, _g32, _g33, _path131, _path132, _path133, _g34, _rect4, _path134, _g35, _g36, _path135, _path136, _path137, _circle6, _path138, _rect5, _path139, _path140, _path141, _path142, _path143, _rect6, _path144, _path145, _path146, _g37, _g38, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _circle7, _path156, _g39, _path157, _path158, _path159, _g40, _g41, _g42, _g43, _rect7, _circle8, _path160, _g44, _g45, _g46, _path161, _path162, _path163, _path164, _path165, _path166, _g47, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _rect8, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _g48, _g49, _g50, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _circle9, _g51, _g52, _g53, _g54, _g55, _path216, _path217, _path218, _path219, _path220, _path221, _g56, _g57, _g58, _g59, _g60, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _circle10, _g61, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _g62, _g63, _path240, _path241, _g64, _g65, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _circle11, _circle12, _path256, _g66, _g67, _g68, _g69, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _circle13, _circle14, _circle15, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _g70, _g71, _g72, _g73, _g74, _g75, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _g76, _g77, _path284, _path285, _g78, _rect9, _path286, _path287, _rect10, _path288, _circle16, _g79, _g80, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _circle17, _path302, _g81, _path303, _path304, _path305, _path306, _path307, _path308, _g82, _g83, _g84, _g85, _path309, _path310, _path311, _path312, _path313, _path314;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 537,
    height: 260,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.006 10A2 2 0 0010 11.992v11.016A1.992 1.992 0 0012.006 25H17V10z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 10v15h4.994A2 2 0 0031 23.008V11.992A1.992 1.992 0 0028.994 10z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-295",
    fill: "#fcd669",
    d: "M17 10h7v15h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 18v.5a2.5 2.5 0 002.5 2.5v-3zm2.5-3H23v3h-2.5z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M18 15h2.5v3H18zm2.5 6a2.5 2.5 0 002.5-2.5V18h-2.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.005 10A2 2 0 0041 11.992v11.016A1.996 1.996 0 0043.005 25H46V10z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 10v5h16v-2.995A2 2 0 0060.006 10z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M46 15h16v5H46z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M46 20v5h14.006A1.997 1.997 0 0062 22.995V20z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M60.999 15H62v5h-1.001z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93 12a2 2 0 00-2-2H74a2 2 0 00-2 2v3h21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.491 10A2.49 2.49 0 0072 12.5V15h21v-2.5a2.505 2.505 0 00-2.491-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#45b2e8",
    d: "M72 15h21v5H72z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M72 19v3a3 3 0 003 3h15a3 3 0 003-3v-3z",
    fill: "#f6f9fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.035 15a3.5 3.5 0 016.93 0z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.19 15l-8.418 9.16a1 1 0 01-1.504-.036L73.645 15 72 13.03V23a2 2 0 002 2h17a2 2 0 002-2v-9.97z",
    fill: "#e25950"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.625 10h15.75c1.45 0 2.625 1.12 2.625 2.5v10c0 1.38-1.175 2.5-2.625 2.5h-15.75c-1.45 0-2.625-1.12-2.625-2.5v-10c0-1.38 1.175-2.5 2.625-2.5z",
    fill: "#E25950"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.563 16.25h7.875l-1.313 2.5h-5.25l-1.313-2.5zm1.968-3.75l-1.969 2.5h3.938l-1.969-2.5zm1.969 10l-2.625-2.5h5.25l-2.625 2.5zm1.969-10L113.5 15h3.938l-1.97-2.5z",
    fill: "#333"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.995 10A1.997 1.997 0 00134 12.005V15h21v-2.995A2.006 2.006 0 00153.005 10z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555abf",
    d: "M134 15h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M134 20v2.995A2.006 2.006 0 00135.995 25h17.01A1.997 1.997 0 00155 22.995V20z",
    fill: "#fcd669"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165 17.5V23a2 2 0 002 2h17a2 2 0 002-2v-5.5h-21z",
    fill: "#333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167 10a2 2 0 00-2 2v5.5h21V12a2 2 0 00-2-2h-17z",
    fill: "#E25950"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.803 20.715c.191.098.392.184.602.256 2.384.827 5.02-.344 5.887-2.615.868-2.27-.361-4.78-2.745-5.607a4.813 4.813 0 00-.634-.172 5.473 5.473 0 012.708.226c2.725.944 4.13 3.814 3.138 6.408-.992 2.595-4.004 3.933-6.729 2.989a5.233 5.233 0 01-2.227-1.485z",
    fill: "#F4B32E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.188 16.25c.724 0 1.312-.56 1.312-1.25s-.588-1.25-1.313-1.25c-.724 0-1.312.56-1.312 1.25s.588 1.25 1.313 1.25z",
    fill: "#F4B32E"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.995 10A1.997 1.997 0 00196 12.005V15h21v-2.995A2.006 2.006 0 00215.005 10z",
    fill: "#45b2e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M196 15h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M196 15h1.001v5H196zm19.999 0H217v5h-1.001z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M196 20v2.995A2.006 2.006 0 00197.995 25h17.01A1.997 1.997 0 00217 22.995V20z",
    fill: "#45b2e8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 17.5,
    r: 1.5,
    fill: "#f4b32e"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.995 10A1.997 1.997 0 00227 12.005V15h21v-2.995A2.006 2.006 0 00246.005 10z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M227 15h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M227 15h1.001v5H227zm19.999 0H248v5h-1.001z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M227 20v2.995A2.006 2.006 0 00228.995 25h17.01A1.997 1.997 0 00248 22.995V20z",
    fill: "#e25950"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260 10h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V12a2 2 0 012-2z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M258 15.664l3.498-2.4.001-.001h.002v.001l5.425 3.722h-1.767l-3.659-2.51-3.5 2.401zm9-5.569v1.213l-3.499 2.4-.001.001-.001-.001-4.758-3.264a1.983 1.983 0 011.121-.444l3.638 2.496z",
    fill: "#f6f9fc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M266.909 17l-3.659-2.51-3.659 2.51H258v-.121l5.248-3.601.001-.001h.002v.001L267 15.85V17zm-5.158-3.278v.001h-.002v-.001l-3.601-2.47a1.99 1.99 0 01.601-.801l3.001 2.059 3.659-2.51H267v.121z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    fill: "#f6f9fc",
    d: "M267 14.625h-3.375V17h-2.25v-2.375H258v-2.25h3.375V10h2.25v2.375H267v2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    fill: "#e25950",
    d: "M267 13.998h-4V17h-1v-3.002h-4v-.996h4V10h1v3.002h4v.996z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M275.24 16.5a.75.75 0 11.75-.75.75.75 0 01-.75.75zm-1.25 3a.5.5 0 11.5-.5.5.5 0 01-.5.5zm-1.25-5a.75.75 0 11.75-.75.75.75 0 01-.75.75zm-3 3a.75.75 0 11.75-.75.75.75 0 01-.75.75zm3 4a.75.75 0 11-.75.75.75.75 0 01.75-.75zm-10.75 1.023l-.684.653a.179.179 0 01-.3-.149l.068-.959-.922-.146a.186.186 0 01-.074-.334l.77-.544-.465-.834a.182.182 0 01.207-.268l.892.282.343-.895a.176.176 0 01.332 0l.343.895.892-.282a.182.182 0 01.207.268l-.465.834.77.544a.186.186 0 01-.074.334l-.922.146.068.959a.179.179 0 01-.3.149z",
    fill: "#f6f9fc"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291 10a2 2 0 00-2 2v3h21v-3a2 2 0 00-2-2h-17z",
    fill: "#217AB7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289 15h21v5h-21v-5z",
    fill: "#E25950"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289 20v3a2 2 0 002 2h17a2 2 0 002-2v-3h-21z",
    fill: "#24B47E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.188 20c.478 0 .926-.122 1.313-.335a2.431 2.431 0 01-.33.023c-1.268 0-2.296-.98-2.296-2.188 0-1.208 1.028-2.188 2.297-2.188.111 0 .221.008.329.023a2.714 2.714 0 00-1.313-.335c-1.45 0-2.626 1.12-2.626 2.5s1.177 2.5 2.626 2.5zm3.937-2.5c0 .69-.588 1.25-1.313 1.25-.724 0-1.312-.56-1.312-1.25s.588-1.25 1.313-1.25c.724 0 1.312.56 1.312 1.25z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322 10a2 2 0 00-2 2v11a2 2 0 002 2h17a2 2 0 002-2V12a2 2 0 00-2-2h-17z",
    fill: "#43458B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.625 10h15.75v15l-15.75-15z",
    fill: "#FCD669"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.625 11.875c0-.345.28-.625.625-.625h.063a.625.625 0 110 1.25h-.063a.625.625 0 01-.625-.625zm1.313 1.25c0-.345.28-.625.624-.625h.063a.625.625 0 110 1.25h-.063a.625.625 0 01-.625-.625zm1.937.625a.625.625 0 100 1.25h.063a.625.625 0 100-1.25h-.063zm.688 1.875c0-.345.28-.625.625-.625h.062a.625.625 0 110 1.25h-.063a.625.625 0 01-.625-.625zm1.937.625a.625.625 0 100 1.25h.063a.625.625 0 100-1.25h-.063zm.688 1.875c0-.345.28-.625.624-.625h.063a.625.625 0 110 1.25h-.063a.625.625 0 01-.624-.625zm1.937.625a.625.625 0 100 1.25h.063a.625.625 0 100-1.25h-.063zm.688 1.875c0-.345.28-.625.624-.625h.063a.625.625 0 110 1.25h-.063a.625.625 0 01-.624-.625zm1.937.625a.625.625 0 100 1.25h.063a.625.625 0 100-1.25h-.063zm.688 1.875c0-.345.28-.625.624-.625h.063a.625.625 0 110 1.25h-.063a.625.625 0 01-.624-.625z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.313 10.625c0-.345.28-.625.625-.625H322a.625.625 0 110 1.25h-.063a.625.625 0 01-.625-.625zm14.437 13.75c0-.345.28-.625.625-.625h.063a.625.625 0 110 1.25h-.063a.625.625 0 01-.625-.625z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.375 10h-15.75v1.25h15.75V10zm-1.313 13.75V25h1.313v-1.25h-1.313z",
    fill: "#A68527",
    fillOpacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    fill: "#159570",
    x: 351,
    y: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M359.5 13a4.5 4.5 0 110 9 4.5 4.5 0 010-9z",
    fill: "#E25950"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcd669",
    d: "M388 10h9v15h-9V10z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M384 10h5v15h-5a2 2 0 01-2-2V12a2 2 0 012-2z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M401 25h-5V10h5a2 2 0 012 2v11a2 2 0 01-2 2z",
    fill: "#e25950"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.995 10A1.991 1.991 0 00413 11.998V18h21v-6.002A2.002 2.002 0 00432.005 10z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-295",
    d: "M413 18v4.994A2.006 2.006 0 00414.995 25h17.01A1.993 1.993 0 00434 22.994V18z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd669",
    d: "M423.5 19.55l-2.645 1.591.705-2.946-2.34-2.186 2.957-.129L423.5 13l1.323 2.88 2.957.129-2.34 2.186.705 2.946-2.645-1.591z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.995 10A1.999 1.999 0 00444 11.998V16h21v-4.002A2.002 2.002 0 00463.005 10z",
    fill: "#f6f9fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.5 15.5h20v-3.502a1.502 1.502 0 00-1.495-1.498h-17.01a1.499 1.499 0 00-1.495 1.498z",
    fill: "none",
    stroke: "#eaeef3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24b47e",
    d: "M444 15h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444 20v2.995A2.006 2.006 0 00445.995 25h17.01A1.997 1.997 0 00465 22.995V20z",
    fill: "#e25950",
    "data-name": "Rectangle-34"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M477.625 10h15.75c1.45 0 2.625 1.12 2.625 2.5v10c0 1.38-1.175 2.5-2.625 2.5h-15.75c-1.45 0-2.625-1.12-2.625-2.5v-10c0-1.38 1.175-2.5 2.625-2.5z",
    fill: "#F6F9FC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M477.625 11.25c-.725 0-1.313.56-1.313 1.25v10c0 .69.588 1.25 1.313 1.25h5.25V25h-5.25c-1.45 0-2.625-1.12-2.625-2.5v-10c0-1.38 1.175-2.5 2.625-2.5h5.25v1.25h-5.25z",
    fill: "#EAEEF3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.378 25h-11.816l1.313-.625-2.625-1.25 2.625-1.25-2.625-1.25 2.625-1.25-2.625-1.25 2.625-1.25-2.625-1.25 2.625-1.25-2.625-1.25 2.625-1.25-2.625-1.25 1.313-.625h11.815c1.446 0 2.622 1.124 2.622 2.51v9.98c0 1.383-1.174 2.51-2.622 2.51z",
    fill: "#E25950"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508 10a2 2 0 00-2 2v11a2 2 0 002 2h5.875V10H508z",
    fill: "#24B47E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M524.56 10c1.346 0 2.44 1.274 2.44 2.846V17.5h-13.125V10h10.685z",
    fill: "#FCD669"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527 22.821c0 1.202-1.093 2.179-2.44 2.179h-10.685v-7.5H527v5.321z",
    fill: "#E25950"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 35h15.75C29.825 35 31 36.12 31 37.5v10c0 1.38-1.175 2.5-2.625 2.5h-15.75C11.175 50 10 48.88 10 47.5v-10c0-1.38 1.175-2.5 2.625-2.5z",
    fill: "#FCD669"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.688 41.25V37.5c0-.69-.588-1.25-1.313-1.25h-15.75c-.725 0-1.313.56-1.313 1.25H10c0-1.38 1.175-2.5 2.625-2.5h15.75C29.825 35 31 36.12 31 37.5v3.75h-1.313zm-18.375 2.5v3.75c0 .69.587 1.25 1.312 1.25h15.75c.725 0 1.313-.56 1.313-1.25H31c0 1.38-1.175 2.5-2.625 2.5h-15.75C11.175 50 10 48.88 10 47.5v-3.75h1.313z",
    fill: "#A68527",
    fillOpacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 36.875l21 3.75v3.75l-21-3.75v-3.75z",
    fill: "#F6F9FC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.313 40.86v-3.75L10 36.874v3.75l1.313.234zM31 40.624l-1.313-.234v3.75l1.313.235v-3.75z",
    fill: "#EAEEF3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 40.625l21 3.75v3.75l-21-3.75v-3.75z",
    fill: "#333"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 40c1.45 0 2.625 1.12 2.625 2.5S21.95 45 20.5 45s-2.625-1.12-2.625-2.5S19.05 40 20.5 40z",
    fill: "#E25950"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.995 35A1.997 1.997 0 0041 37.005V40h21v-2.995A2.006 2.006 0 0060.005 35z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd669",
    d: "M41 40h21v5H41z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M41 45v2.995A2.006 2.006 0 0042.995 50h17.01A1.997 1.997 0 0062 47.995V45z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efc65e",
    d: "M41 40h1.001v5H41zm19.999 0H62v5h-1.001z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 35h17a2 2 0 012 2v11a2 2 0 01-2 2H74a2 2 0 01-2-2V37a2 2 0 012-2z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    fill: "#fcd669",
    d: "M82.999 37l8.999 6.004-8.999 6.004L74 43.004 82.999 37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.051 41.993A3.477 3.477 0 0079 42.5a3.483 3.483 0 005.766 2.648 8.588 8.588 0 00-5.716-3.155zm6.523 2.147A3.461 3.461 0 0086 42.5a3.489 3.489 0 00-6.54-1.702 9.848 9.848 0 016.114 3.342z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.46 40.798a3.451 3.451 0 00-.408 1.195 8.588 8.588 0 015.714 3.155 3.49 3.49 0 00.808-1.008 9.848 9.848 0 00-6.114-3.342z",
    fill: "#fff"
  })))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105 35a2 2 0 00-2 2v11a2 2 0 002 2h17a2 2 0 002-2V37a2 2 0 00-2-2h-17z",
    fill: "#FCD669"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M122.688 45v-5H124v5h-1.313z",
    fill: "#A68527",
    fillOpacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103 37a2 2 0 012-2h17a2 2 0 012 2v3h-21v-3zm0 11v-3h21v3a2 2 0 01-2 2h-17a2 2 0 01-2-2z",
    fill: "#45B2E8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.92 49.4a2.465 2.465 0 01-.92-1.91v-9.98c0-.766.36-1.454.928-1.915.032.013.063.03.092.049l10.793 6.852-10.793 6.851a.673.673 0 01-.1.052z",
    fill: "#333"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.375 50h-15.75c-1.45 0-2.625-1.12-2.625-2.5v-10c0-1.38 1.175-2.5 2.625-2.5h15.75c1.45 0 2.625 1.12 2.625 2.5v10c0 1.38-1.175 2.5-2.625 2.5z",
    fill: "#FCD669"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.375 35h-15.75c-1.45 0-2.625 1.12-2.625 2.5v10c0 1.38 1.175 2.5 2.625 2.5h15.75c1.45 0 2.625-1.12 2.625-2.5v-10c0-1.38-1.175-2.5-2.625-2.5zm-15.75 13.75c-.725 0-1.313-.56-1.313-1.25v-10c0-.69.588-1.25 1.313-1.25h15.75c.725 0 1.313.56 1.313 1.25v10c0 .69-.588 1.25-1.313 1.25h-15.75z",
    fill: "#A68527",
    fillOpacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.625 50a2.69 2.69 0 01-1.743-.63l19.236-13.74c.54.458.882 1.126.882 1.87v10c0 1.38-1.175 2.5-2.625 2.5h-15.75z",
    fill: "#E25950"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M140.563 45h2.625v-2.5h2.624V40h2.626",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165 38.75v7.5h21v-7.5h-21z",
    fill: "#F6F9FC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.313 40H165v5h1.313v-5zm18.375 0v5H186v-5h-1.313z",
    fill: "#EAEEF3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165 37a2 2 0 012-2h17a2 2 0 012 2v3h-21v-3zm0 11v-3h21v3a2 2 0 01-2 2h-17a2 2 0 01-2-2z",
    fill: "#45B2E8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165 41.25v2.5h21v-2.5h-21z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M201 35h11v15h-11V35z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M212 36h-11v-1h11zm-11 13h11v1h-11z",
    fill: "#e25950",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M206.045 45.97l-.003-1.974-1.399-.008.177-.819-1.82-.277.647-1.197-.58-1.585 1.593.634.471-1.818.698.356.668-1.283.76 1.264.621-.286.299 1.757 1.773-.557-.545 1.47.595 1.235-1.76.287.161.811-1.442-.014.008 1.985zM202 50h-4a2 2 0 01-2-2V37a2 2 0 012-2h4zm13 0h-4V35h4a2 2 0 012 2v11a2 2 0 01-2 2z",
    fill: "#e25950"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 3,
    ry: 3,
    fill: "#fcd669",
    x: 227,
    y: 35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.992 35A1.99 1.99 0 00227 37v8l15-10z",
    fill: "#45b2e8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 38,
    r: 1,
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-87",
    d: "M248 48a1.997 1.997 0 01-1.992 2H233l15-10z",
    fill: "#45b2e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 35h-1l-18 12v1a2 2 0 002 2h1l18-12v-1a2 2 0 00-2-2z",
    fill: "#e25950"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277 35h-3l-15.393 14.431A1.99 1.99 0 00260 50h3l15.393-14.431A1.99 1.99 0 00277 35z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 35a2 2 0 00-2 2v11a1.991 1.991 0 00.607 1.431L274 35z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 50h14a2 2 0 002-2V37a1.991 1.991 0 00-.607-1.431z",
    fill: "#e25950"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291 35h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V37a2 2 0 012-2z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M304 44h-3v3h-3v-3h-3v-3h3v-3h3v3h3v3z"
  })))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M327 35h7v15h-7V35z",
    fill: "#F6F9FC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M327 35h7v1h-7v-1z",
    fill: "#EAEEF3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M322.8 35h4.2v15h-4.2c-1.546 0-2.8-1.12-2.8-2.5v-10c0-1.38 1.254-2.5 2.8-2.5z",
    fill: "#F79A59"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M338.2 50H334V35h4.2c1.546 0 2.8 1.12 2.8 2.5v10c0 1.38-1.254 2.5-2.8 2.5z",
    fill: "#24B47E"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.499 43.5v-8h10.492a1.505 1.505 0 011.509 1.498V43.5z",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.991 36a1.004 1.004 0 011.009.997V43h-11v-7h9.992m0-1h-10.993v9H372v-7.003A2.005 2.005 0 00369.991 35z",
    fill: "#e9ebf0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 43v4.994A2.006 2.006 0 00352.995 50h17.01A1.993 1.993 0 00372 47.994V43z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-295",
    d: "M352.997 35A1.993 1.993 0 00351 36.998V43h9v-8z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.34 38.422l-1.169.002a.162.162 0 01-.154-.112l-.362-1.112a.162.162 0 00-.31 0l-.36 1.111a.162.162 0 01-.155.113h-1.17a.162.162 0 00-.095.294l.946.687a.162.162 0 01.058.182l-.359 1.113a.162.162 0 00.25.182l.946-.634a.162.162 0 01.191 0l.946.634a.162.162 0 00.25-.182l-.361-1.111a.162.162 0 01.059-.183l.946-.687a.162.162 0 00.06-.182.165.165 0 00-.156-.114z",
    fill: "#fff"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.006 35A2 2 0 00382 36.992v11.016A1.992 1.992 0 00384.006 50H389V35z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396 35v15h4.994A2 2 0 00403 48.008V36.992A1.992 1.992 0 00400.994 35z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-295",
    fill: "#e25950",
    d: "M388 35h9v15h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.625 41.302l-2.014.005a.28.28 0 01-.267-.194l-.624-1.917a.28.28 0 00-.534 0l-.622 1.916a.28.28 0 01-.266.194h-2.015a.28.28 0 00-.165.507l1.63 1.185a.28.28 0 01.102.314l-.622 1.916a.28.28 0 00.432.314l1.63-1.093a.28.28 0 01.33 0l1.63 1.093a.28.28 0 00.432-.314l-.624-1.916a.28.28 0 01.102-.314l1.63-1.185a.28.28 0 00.103-.313.284.284 0 00-.268-.198z",
    fill: "#fcd669"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    ry: 2,
    fill: "#e25950",
    x: 413,
    y: 35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 38a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-96",
    d: "M426.5 40a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.5 42a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-96",
    d: "M425.5 44a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd669",
    d: "M419.471 43.588L417.013 45l.609-2.757-1.651-2.068 2.48-.138 1.02-2.137 1.021 2.137 2.479.138-1.651 2.068.689 2.757-2.538-1.412z"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.995 35A1.993 1.993 0 00444 37.006V42h21v-4.994A2.006 2.006 0 00463.005 35z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43458b",
    d: "M444 42h21v4h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M444 46v2a2.003 2.003 0 001.995 2h17.01A1.992 1.992 0 00465 48v-2z",
    fill: "#e25950"
  })))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M496 38h-21v-1a2 2 0 012-2h17a2 2 0 012 2z",
    fill: "#0172c6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M475 38h21v2h-21zm0 7h21v2h-21z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M475 47h21v1a2 2 0 01-2 2h-17a2 2 0 01-2-2z",
    fill: "#0172c6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#e25950",
    d: "M475 40h21v5h-21z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M479.52 40a2.5 2.5 0 102.48 2.54 2.5 2.5 0 00-2.48-2.54zm0 4a1.5 1.5 0 111.48-1.46 1.5 1.5 0 01-1.48 1.46z",
    fill: "#f9f9f9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 479.52,
    cy: 42.54,
    r: 1.5,
    fill: "#0172c6"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M508 35h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V37a2 2 0 012-2z",
    fill: "#f6f9fc"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M525 50h-17a2 2 0 01-2-2V37a2 2 0 012-2h17a2 2 0 012 2v11a2 2 0 01-2 2zm1-13a1 1 0 00-1-1h-17a1 1 0 00-1 1v11a1 1 0 001 1h17a1 1 0 001-1z",
    style: {
      isolation: "isolate"
    },
    fill: "#8898aa",
    opacity: 0.2
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M521.28 42.2h-1a3.85 3.85 0 01-7.46 0h-1a4.89 4.89 0 003.42 3.71 1.55 1.55 0 00.25 1.87l1.11-1.11 1.11 1.11a1.55 1.55 0 00.25-1.87 4.89 4.89 0 003.32-3.71z",
    fill: "#24b47e"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M513.06 40.7a2.38 2.38 0 002.29 2.18l.64.55h.35a2.06 2.06 0 011.78-1.37s.16-1 .79-1h1.67a3.4 3.4 0 011.9-3.37l-1-.47A7.45 7.45 0 01516 39.2a1.26 1.26 0 01-.25.91c-.27.28-.74 0-.74 0s-.28-.52-.56-.56-1.39 1.15-1.39 1.15z",
    fill: "#f79a59"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M30 67v-5a1 1 0 00-1-1H12a.981.981 0 00-.325.066L21 67zm-19.335 7.48a1.991 1.991 0 00.596.375 1.998 1.998 0 01-.595-.375z",
    fill: "#f6f9fc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.665 74.48a1.991 1.991 0 00.596.375 1.998 1.998 0 01-.595-.375z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M29 60H12a1.982 1.982 0 00-1.29.484.788.788 0 01.135.054l.83.528A.981.981 0 0112 61h17a1 1 0 011 1v5h1v-5a2 2 0 00-2-2z",
    fill: "#f6f9fc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29 60H12a1.982 1.982 0 00-1.29.484.788.788 0 01.135.054l.83.528A.981.981 0 0112 61h17a1 1 0 011 1v5h1v-5a2 2 0 00-2-2z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M11.995 75H12a1.988 1.988 0 01-.739-.145 1.966 1.966 0 00.734.145zM29 75h.005A1.991 1.991 0 0031 73.002V73a2 2 0 01-2 2z",
    fill: "#e25950"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M30 67h-9l-9.456 6.877-.735.535a.774.774 0 01-.143.067A1.982 1.982 0 0012 75h17a2 2 0 002-2v-6z",
    fill: "#e25950"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M10.04 73.403c-.008-.04-.006-.085-.012-.128.006.043.004.087.013.128zm.035.111a1.99 1.99 0 00.59.966 1.994 1.994 0 01-.59-.966zM10 73v.002a1.957 1.957 0 00.028.273A1.969 1.969 0 0110 73zm.075.514c-.01-.037-.026-.072-.034-.11.008.038.024.073.034.11z",
    fill: "#43458b"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M11.675 61.066l-.83-.528a.788.788 0 00-.136-.054A1.986 1.986 0 0010 62v11a1.969 1.969 0 00.028.275c.006.043.004.087.013.128.008.039.024.074.034.111a1.994 1.994 0 00.591.965.774.774 0 00.143-.067l.735-.535L21 67z",
    fill: "#43458b"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e25950",
    d: "M41 64h21v7H41v-7z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M41 73v-3h21v3a2 2 0 01-2 2H43a2 2 0 01-2-2z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M62 62v3H41v-3a2 2 0 012-2h17a2 2 0 012 2z",
    fill: "#333"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 67v6.002A2.002 2.002 0 0073.995 75h17.01A1.991 1.991 0 0093 73.002V67z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-295",
    d: "M72 62v6h21v-6a2 2 0 00-2-2H74a2 2 0 00-2 2z",
    fill: "#45b2e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.647 61.623c-.91-.62-1.647-.226-1.647.883v9.988c0 1.108.773 1.549 1.719.99L84 68z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.796 66.845l-1.458.004a.202.202 0 01-.193-.14l-.452-1.389a.202.202 0 00-.386 0l-.45 1.387a.202.202 0 01-.193.14h-1.46a.202.202 0 00-.118.367l1.18.858a.202.202 0 01.073.227l-.45 1.387a.202.202 0 00.313.228l1.18-.792a.202.202 0 01.238 0l1.18.792a.202.202 0 00.313-.227L77.66 68.3a.202.202 0 01.074-.227l1.18-.858a.202.202 0 00.075-.227.205.205 0 00-.194-.143z",
    fill: "#e25950"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M105 60h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V62a2 2 0 012-2z",
    fill: "#e25950"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    fill: "#f6f9fc",
    d: "M124 69h-12v6h-3v-6h-6v-3h6v-6h3v6h12v3z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M123 70v-5h1v5zm-15 4h5v1h-5zm0-14h5v1h-5zm-5 5h1v5h-1z",
    fill: "#e25950",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#e25950",
    d: "M136 60h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V62a2 2 0 012-2z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M155 69h-9v6h-2.99v-6H134v-3h9v-6h3v6h9v3z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#555abf",
    d: "M154 69v-3h1v3zm-11 5h3v1h-3zm-9-8h1v3h-1zm9-6h3v1h-3z",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#43458b",
    d: "M136 60h7v6h-9v-4.01a1.99 1.99 0 012-1.99zm17.02 15H146v-6h9v4.01a1.98 1.98 0 01-1.98 1.99z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#24b47e",
    cx: 144.5,
    cy: 67.5,
    r: 0.95
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M171 60v15h13.008A1.993 1.993 0 00186 73.008V61.992A1.993 1.993 0 00184.008 60z",
    fill: "#f6f9fc"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-87",
    d: "M167 60a1.997 1.997 0 00-2 1.992v11.016A1.99 1.99 0 00167 75h8V60z",
    fill: "#24b47e"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M175 63.027v1.021a3.531 3.531 0 00-3 3.452 3.531 3.531 0 003 3.452v1.02a4.5 4.5 0 110-8.945z",
    fill: "#e25950"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Oval-38",
    d: "M178.482 65.403A3.63 3.63 0 00175.6 64a3.551 3.551 0 00-3.6 3.5 3.551 3.551 0 003.6 3.5 3.63 3.63 0 002.882-1.403 4.5 4.5 0 110-4.194z",
    fill: "#e25950"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.5,
    cy: 67.5,
    r: 1.5,
    fill: "#e25950"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184 61a1 1 0 011 1v11a1 1 0 01-1 1h-9v1h9a2 2 0 002-2V62a2 2 0 00-2-2h-9v1z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M198 60h17a2 2 0 012 2v5h-21v-5a2 2 0 012-2z",
    fill: "#ffdd03"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#555abf",
    d: "M196 67h21v4h-21z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M196 71h21v2a2 2 0 01-2 2h-17a2 2 0 01-2-2v-2z",
    fill: "#e25950"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 64a3.5 3.5 0 103.5 3.5 3.5 3.5 0 00-3.5-3.5zm0 6a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5z",
    fill: "#ffdd03"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 67.5,
    r: 2.5,
    fill: "#6fc242"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M228.995 60A1.997 1.997 0 00227 62.005V65h21v-2.995A2.006 2.006 0 00246.005 60z",
    fill: "#45b2e8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M227 69v4.002A2.002 2.002 0 00228.995 75h17.01A1.999 1.999 0 00248 73.002V69z",
    fill: "#f6f9fc",
    "data-name": "Rectangle-34"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246 75h-17a2 2 0 01-2-2v-6h1v6a1 1 0 001 1h17a1 1 0 001-1v-6h1v6a2 2 0 01-2 2z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M227 65h21v5h-21z"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.995 60A1.997 1.997 0 00258 62.005V65h21v-2.995A2.006 2.006 0 00277.005 60z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M258 65h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M258 70v2.995A2.006 2.006 0 00259.995 75h17.01A1.997 1.997 0 00279 72.995V70z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 66l3 1-3 2zm7 0v3l-3-2zm-4 2h1v1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "path-141",
    d: "M265 66l3 1-3 2zm7 0v3l-3-2zm-4 2h1v1h-1z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M258 65h1.001v5H258zm19.999 0H279v5h-1.001z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd669",
    d: "M289 63h21v9h-21v-9z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M289 64v-2a2 2 0 012-2h17a2 2 0 012 2v2zm19 11h-17a2 2 0 01-2-2v-2h21v2a2 2 0 01-2 2z",
    fill: "#e25950"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    fill: "#f6f9fc",
    d: "M294 65h2v2.5h-2V65z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M294 70a2 2 0 01-2-2v-.5h2z",
    fill: "#e25950",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M294 70v-2.5h2v.5a2 2 0 01-2 2zm-2-5h2v2.5h-2z",
    fill: "#e25950"
  })))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322 60a2 2 0 00-2 2v3h21v-3a2 2 0 00-2-2h-17z",
    fill: "#24B47E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320 65h21v5h-21v-5z",
    fill: "#FCD669"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.313 65H320v5h1.313v-5zm18.375 0v5H341v-5h-1.313z",
    fill: "#A68527",
    fillOpacity: 0.1
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320 70v3a2 2 0 002 2h17a2 2 0 002-2v-3h-21z",
    fill: "#E25950"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.5 71.25c2.175 0 3.938-1.679 3.938-3.75 0-2.071-1.763-3.75-3.938-3.75-2.175 0-3.938 1.679-3.938 3.75 0 2.071 1.763 3.75 3.938 3.75z",
    fill: "#45B2E8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M332.793 66.628l-1.495.003a.207.207 0 01-.198-.137l-.463-1.355a.206.206 0 00-.198-.139.207.207 0 00-.198.139l-.462 1.354a.207.207 0 01-.198.137h-1.496a.207.207 0 00-.2.137.192.192 0 00.078.222l1.21.838c.073.05.103.14.075.221l-.462 1.356a.19.19 0 00.074.223c.074.051.174.05.247-.002l1.21-.773a.216.216 0 01.245 0l1.21.773a.216.216 0 00.246.002.192.192 0 00.075-.223l-.463-1.356a.192.192 0 01.075-.221l1.21-.838a.192.192 0 00.077-.222.21.21 0 00-.199-.14z",
    fill: "#FCD669"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353 60h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V62a2 2 0 012-2z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M365.906 68.219a.844.844 0 11.844-.844.843.843 0 01-.844.844zm-1.895-3.444a.849.849 0 111.19-.01.849.849 0 01-1.19.01zm1.165 5.2A.85.85 0 11364 70a.85.85 0 011.176-.025zm-3.801 2.775a.844.844 0 11.844-.844.844.844 0 01-.844.844zm0-9.063a.844.844 0 11.843-.844.843.843 0 01-.843.844zm-3.765 7.489a.849.849 0 111.19-.01.849.849 0 01-1.19.01zm-.036-6.401a.85.85 0 011.201-1.201.85.85 0 01-1.201 1.201zm.113 2.6a.844.844 0 11-.844-.843.843.843 0 01.844.843z",
    fill: "#fce883"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M384 60h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V62a2 2 0 012-2z",
    fill: "#f6f9fc"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M401 75h-17a2 2 0 01-2-2V62a2 2 0 012-2h17a2 2 0 012 2v11a2 2 0 01-2 2zm1-13a1 1 0 00-1-1h-17a1 1 0 00-1 1v11a1 1 0 001 1h17a1 1 0 001-1z",
    fill: "#8898aa",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    fill: "#555abf",
    d: "M403 69h-12v6h-3v-6h-6v-3h6v-6h3v6h12v3z"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    fill: "#f6f9fc",
    x: 413,
    y: 60
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M432 61a1 1 0 011 1v11a1 1 0 01-1 1h-17a1 1 0 01-1-1V62a1 1 0 011-1h17m0-1h-17a2 2 0 00-2 2v11a2 2 0 002 2h17a2 2 0 002-2V62a2 2 0 00-2-2z",
    fill: "#eaeef3"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#0172c6",
    d: "M434 66h-13.42v-6h-3v6H413v3h4.58v6h3v-6H434v-3z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#e25950",
    d: "M434 67h-14.42v-7h-1v7H413v1h5.58v7h1v-7H434v-1z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M450 60h9v15h-9V60z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M450 75v-1h9v1zm0-15h9v1h-9z",
    fill: "#8898aa",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M446 60h5v15h-5a2 2 0 01-2-2V62a2 2 0 012-2z",
    fill: "#555abf"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M463 75h-5V60h5a2 2 0 012 2v11a2 2 0 01-2 2z",
    fill: "#e25950"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.995 60A1.997 1.997 0 00475 62.005V65h21v-2.995A2.006 2.006 0 00494.005 60z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd669",
    d: "M475 65h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M475 70v2.995A2.006 2.006 0 00476.995 75h17.01A1.997 1.997 0 00496 72.995V70z",
    fill: "#217ab7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9c863",
    d: "M475 65h1.001v5H475zm20 0h1.001v5H495z"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M526.929 73.5H524.5V75h-16v-1.5h-2.429A1.966 1.966 0 01506 73V62a1.966 1.966 0 01.071-.5h2.429V60h16v1.5h2.429a1.966 1.966 0 01.071.5v11a1.966 1.966 0 01-.071.5z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M523.659 60H525a2 2 0 012 2v.454L523.629 65H527v5h-3.288L527 72.483V73a2 2 0 01-2 2h-1.258L519 71.419V75h-5v-3.581L509.258 75H508a2 2 0 01-2-2v-.517L509.288 70H506v-5h3.371L506 62.454V62a2 2 0 012-2h1.341L514 63.519V60h5v3.519z",
    fill: "#f6f9fc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M518 69v6h-3v-6h-9v-3h9v-6h3v6h9v3zm.5-3.5v-.218l6.929-5.233a1.99 1.99 0 011.138.722l-6.261 4.729zm-12.291-4.374a2.005 2.005 0 01.896-.906l6.99 5.28h-2.094zM514.5 69.5v.218l-6.929 5.233a1.99 1.99 0 01-1.138-.722l6.261-4.729zm12.291 4.374a2 2 0 01-.896.906l-6.99-5.28h2.094z",
    fill: "#e25950"
  })))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 85a2 2 0 00-2 2v3h21v-3a2 2 0 00-2-2H12z",
    fill: "#E25950"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 90h21v5H10v-5z",
    fill: "#FCD669"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.313 90H10v5h1.313v-5zm18.375 0v5H31v-5h-1.313z",
    fill: "#A68527",
    fillOpacity: 0.1
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 95v3a2 2 0 002 2h17a2 2 0 002-2v-3H10z",
    fill: "#24B47E"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M23.514 91.458l-1.914.004a.264.264 0 01-.253-.175l-.593-1.734a.264.264 0 00-.254-.178.264.264 0 00-.253.178l-.591 1.733a.265.265 0 01-.253.176h-1.915a.265.265 0 00-.256.174.246.246 0 00.1.285l1.548 1.072c.093.064.132.18.096.284l-.591 1.734a.246.246 0 00.095.287.276.276 0 00.316-.003l1.548-.99a.276.276 0 01.313 0l1.55.99a.276.276 0 00.315.003.246.246 0 00.095-.287l-.593-1.734a.246.246 0 01.097-.284l1.55-1.072a.246.246 0 00.097-.284.268.268 0 00-.254-.179z",
    fill: "#333"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea2c3f",
    d: "M60 100a2 2 0 002-2v-6H41v6a2 2 0 002 2z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M41 93v-6a2 2 0 012-2h17a2 2 0 012 2v6z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#8898aa",
    d: "M43 85h17a2 2 0 012 2v6h-1v-6a1 1 0 00-1-1H43a1 1 0 00-1 1v6h-1v-6a2 2 0 012-2z",
    opacity: 0.2
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#e25950",
    d: "M62 92v6a2 2 0 01-2 2H43a2 2 0 01-2-2v-6zm-7.35-2.43h.48v-.66h-.71v-1h.23v-.65h-1.83v.66h.23v1h-.51v-1.71h.23v-.66h-2.54v.66h.23v1.7H50v-1h.23v-.65h-1.88v.66h.23v1h-.71v.66h.48v1.87h6.31m-3.54-2.54v-.55a.38.38 0 01.76 0v.55z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffdd03",
    d: "M51.54 93.09a1.25 1.25 0 111.21-1.25 1.25 1.25 0 01-1.21 1.25z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M51.5 92.34a.5.5 0 01-.5-.5.5.5 0 01.5-.5.5.5 0 010 1z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffdd03",
    d: "M51 92.64v2h-1v1h2v-3h-1z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M74 85h17a2 2 0 012 2v5.5H72V87a2 2 0 012-2z",
    fill: "#f6f9fc"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M91 86a1 1 0 011 1v5.5h1V87a2 2 0 00-2-2H74a2 2 0 00-2 2v5.5h1V87a1 1 0 011-1h17",
    fill: "#eaeef3"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 92.5a4 4 0 018 0zm4 0H72V98a2 2 0 002 2h17a2 2 0 002-2v-5.5h-4.5",
    fill: "#e25950"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 92.5a4 4 0 01-8 0z",
    fill: "#fff"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M103 89h21v7h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.995 85A1.992 1.992 0 00103 87v2h21v-2a2.003 2.003 0 00-1.995-2z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43458b",
    d: "M103 90h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M103 96v2a2.003 2.003 0 001.995 2h17.01A1.992 1.992 0 00124 98v-2z",
    fill: "#24b47e"
  })))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M153 85h-17a2 2 0 00-2 2v11a2 2 0 002 2h17a2 2 0 002-2V87a2 2 0 00-2-2z",
    fill: "#555abf"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M134 89h10v2h-10z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M140 85v10h-2V85zm4 2h11v2h-11z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M154 87h1v2h-1z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M144 91h11v2h-11z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M154 91h1v2h-1z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M134 95h21v2h-21z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M154 95h1v2h-1z"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.006 85A2 2 0 00165 86.992v11.016a1.992 1.992 0 002.006 1.992H172V85zM179 85v15h4.994A2 2 0 00186 98.008V86.992A1.992 1.992 0 00183.994 85z",
    fill: "#45b2e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M172 85h7v15h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5 94a1.5 1.5 0 111.5-1.5 1.502 1.502 0 01-1.5 1.5zm0-2a.5.5 0 10.5.5.5.5 0 00-.5-.5z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M172 100v-1.001h7v1zm0-14v-1h7v1z"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 86,
    width: 19,
    height: 13,
    rx: 1.77,
    fill: "#0172c6"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M214.23 86a1.77 1.77 0 011.77 1.77v9.46a1.77 1.77 0 01-1.77 1.77h-15.46a1.77 1.77 0 01-1.77-1.77v-9.46a1.77 1.77 0 011.77-1.77h15.46m0-1h-15.46a2.77 2.77 0 00-2.77 2.77v9.46a2.77 2.77 0 002.77 2.77h15.46a2.77 2.77 0 002.77-2.77v-9.46a2.77 2.77 0 00-2.77-2.77z",
    fill: "#e25950"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd669",
    d: "M207 96h-1l-2-2h5l-2 2z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cdbff",
    d: "M207 89h-1l-2.17 2.35L204 93h5l.21-1.58L207 89z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M204.5 94h1l-1-2v2z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M207 92a4.38 4.38 0 011 3",
    fill: "none",
    stroke: "#0a9362",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 89.19c1 .67 2.5 2 2.5 3.31s-1.52 2.63-2.5 3.31c-1-.67-2.5-2-2.5-3.31s1.52-2.63 2.5-3.31m0-1.19s-3.5 2-3.5 4.5 3.5 4.5 3.5 4.5 3.5-2 3.5-4.5-3.5-4.5-3.5-4.5z",
    fill: "#e25950"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 92,
    r: 1,
    fill: "#0a9362"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.167 85a2 2 0 00-2 2v11a2 2 0 002 2h14.666a2 2 0 002-2V87a2 2 0 00-2-2h-14.666z",
    fill: "#24B47E"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M227 97.49v-9.98l.001-.095c.044-1.518 1.343-2.431 2.647-1.893l18.338 6.978-3.096 1.178-15.214 5.79c-1.332.548-2.63-.352-2.675-1.891l-.001-.088z",
    fill: "#fff"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.167 97.49V87.453c.02-.649.5-.998 1.09-.755L244.5 92.5l-15.243 5.8c-.59.244-1.07-.093-1.09-.752v-.059z",
    fill: "#FCD669"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.942 99.36a2.595 2.595 0 01-.775-1.87v-9.98c0-.741.3-1.41.775-1.87.05.03.101.065.154.107L237.5 92.5l-8.404 6.754a1.191 1.191 0 01-.154.106z",
    fill: "#333"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.354 98.477a2.67 2.67 0 01-.187-.988v-9.978c0-.422.096-.82.267-1.17l7.316 6.159c-3.772 3.23-6.238 5.222-7.396 5.977z",
    fill: "#E25950"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260 85h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V87a2 2 0 012-2z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.31 92.4a2.311 2.311 0 011.77-1.903c1.389-.542 2.732.89 2.91 1.681-.054.046-.147-.023-.27-.093a.492.492 0 00-.56-.032c-.384.259-.466.476-.916.632a1.226 1.226 0 01-1.247-.329 1.22 1.22 0 00-1.686.044m-.271.441a2.31 2.31 0 01-2.55.5c-1.441-.379-1.686-2.326-1.365-3.071.159-.013.136.573.598.589a2.813 2.813 0 00.41-.018 1.552 1.552 0 01.702.046 1.224 1.224 0 01.816.998 1.22 1.22 0 001.389.956m.36.091a2.311 2.311 0 01-.357 2.574c-.827 1.239-2.748.837-3.347.291.039-.156.585.057.75-.374s.11-.657.39-1.043a1.225 1.225 0 011.209-.446 1.22 1.22 0 001.355-1.002m.114-.311a2.311 2.311 0 012.357 1.094c.943 1.153-.003 2.873-.7 3.287-.138-.083.226-.543-.14-.828s-.595-.296-.882-.677a1.224 1.224 0 01-.073-1.287 1.22 1.22 0 00-.562-1.589m-.541-.119a2.308 2.308 0 01-1.223-2.292c-.06-1.489 1.731-2.293 2.537-2.203.06.149-.508.297-.388.744s.298.596.298 1.072a1.225 1.225 0 01-.716 1.072 1.218 1.218 0 00-.507 1.607",
    fill: "#fff"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.995 85A1.997 1.997 0 00289 87.005V90h21v-2.995A2.006 2.006 0 00308.005 85z",
    fill: "#45b2e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M289 90h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M289 95v2.995a2.006 2.006 0 001.995 2.005h17.01A1.997 1.997 0 00310 97.995V95z",
    fill: "#45b2e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M289 90h1.001v5H289zm19.999 0H310v5h-1.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 92.5a.5.5 0 11.5.5.5.5 0 01-.5-.5zm-3-1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm0 2a.5.5 0 11.5.5.5.5 0 01-.5-.5zm6 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm0-2a.5.5 0 11.5.5.5.5 0 01-.5-.5z",
    fill: "#45b2e8"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.995 85A1.997 1.997 0 00320 87.005V90h21v-2.995A2.006 2.006 0 00339.005 85h-17.01z",
    fill: "#E25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 90h-21v5h21v-5z",
    fill: "#F6F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 95v2.995a2.006 2.006 0 001.995 2.005h17.01A1.996 1.996 0 00341 97.995V95h-21z",
    fill: "#43458B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.202 89h5v4.5a2.5 2.5 0 01-2.5 2.5 2.5 2.5 0 01-2.5-2.5V89z",
    fill: "#F6F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M340 95.024V90.01h1v5.013h-1zm-20-5.014h1v5.013h-1V90.01z",
    fill: "#555ABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.924 89.985h-1.072v1.072h1.072v-1.072z",
    fill: "#F6F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.994 89.985h-1.072v1.072h1.072v-1.072z",
    fill: "#E25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.063 89.985h-1.072v1.072h1.072v-1.072z",
    fill: "#F6F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.161 89.985h-1.1v1.072h1.1v-1.072zm-3.237 1.065h-1.072v1.07h1.072v-1.07z",
    fill: "#E25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.994 91.05h-1.072v1.07h1.072v-1.07z",
    fill: "#F6F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.063 91.05h-1.071v1.07h1.071v-1.07z",
    fill: "#E25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.133 91.05h-1.072v1.07h1.072v-1.07zm-3.209 1.064h-1.072v1.071h1.072v-1.071z",
    fill: "#F6F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.994 92.113h-1.072v1.072h1.072v-1.072z",
    fill: "#E25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.063 92.114h-1.072v1.071h1.072v-1.071z",
    fill: "#F6F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.161 92.113h-1.1v1.072h1.1v-1.072zm-3.237 1.064h-1.072v1.073h1.072v-1.073z",
    fill: "#E25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.994 93.178h-1.072v1.071h1.072v-1.071z",
    fill: "#F6F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.063 93.177h-1.071v1.073h1.071v-1.073z",
    fill: "#E25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.133 93.178h-1.072v1.071h1.072v-1.071zm-3.209 1.058h-1.072v1.072h1.072v-1.072z",
    fill: "#F6F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.994 94.236h-1.072v1.48h1.072v-1.48z",
    fill: "#E25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.063 94.236h-1.072v1.072h1.072v-1.072z",
    fill: "#F6F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.133 94.236h-1.072v1.072h1.072v-1.072z",
    fill: "#E25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.134 89.585v3.848a2.138 2.138 0 01-4.275 0v-3.848h4.275zm.855-.855h-5.985v4.703a2.993 2.993 0 002.993 2.992 2.992 2.992 0 002.992-2.992V88.73z",
    fill: "#E25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328 88.956l.602-.556.598.556v1.049H328v-1.049z",
    fill: "#43458B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.193 88.956l.602-.556.598.556v1.049h-1.2v-1.049z",
    fill: "#0172C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.384 88.956l.603-.556.598.556v1.049h-1.201v-1.049z",
    fill: "#43458B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.577 88.956l.603-.556.598.556v1.049h-1.201v-1.049z",
    fill: "#0172C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.769 88.956l.602-.556.598.556v1.049h-1.2v-1.049z",
    fill: "#43458B"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.995 85A1.991 1.991 0 00351 86.998V93h21v-6.002A2.002 2.002 0 00370.005 85z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-295",
    d: "M351 93v4.994a2.006 2.006 0 001.995 2.006h17.01A1.993 1.993 0 00372 97.994V93z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M357 90h9v5h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-927",
    d: "M365.902 95h-8.804c.454-1.141 2.408-2 4.401-2s3.947.859 4.402 2zm-5.402-4h2v1l-.983 1-1.017-1z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 92h1v1h-1zm4 0h1v1h-1z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-930",
    d: "M358 91h1v1h-1zm6 0h1v1h-1z",
    fill: "#fcd669"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.995 85A1.997 1.997 0 00382 87.005V90h21v-2.995A2.006 2.006 0 00401.005 85z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M382 90h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M382 95v2.995a2.006 2.006 0 001.995 2.005h17.01A1.997 1.997 0 00403 97.995V95z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M382 90h1.001v5H382zm19.999 0H403v5h-1.001z"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413 92v6.002a2.002 2.002 0 001.995 1.998h17.01A1.991 1.991 0 00434 98.002V92z",
    fill: "#f6f9fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.5 92.5v5.502a1.502 1.502 0 001.495 1.498h17.01a1.491 1.491 0 001.495-1.498V92.5z",
    fill: "none",
    stroke: "#eaeef3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.995 85A1.991 1.991 0 00413 86.998V93h21v-6.002A2.002 2.002 0 00432.005 85z",
    fill: "#e25950"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M450 85h9v15h-9V85z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M450 100v-1h9v1zm0-15h9v1h-9z",
    fill: "#8898aa",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M446 85h5v15h-5a2 2 0 01-2-2V87a2 2 0 012-2z",
    fill: "#24b47e"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M463 100h-5V85h5a2 2 0 012 2v11a2 2 0 01-2 2z",
    fill: "#f79a59"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.493 85A1.493 1.493 0 00475 86.5V88h21v-1.5a1.5 1.5 0 00-1.493-1.5z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M476.001 88h18.998v9h-18.998z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.125 92.5L486 91h-1l-1.125 1.5L485 94h1zm.75 0L489 94h-2l-1.5 2.5L484 94h-2l1.125-1.5L482 91h2l1.5-2.5L487 91h2z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M475 97v1.5a1.5 1.5 0 001.493 1.5h18.014A1.493 1.493 0 00496 98.5V97z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M475 88h1.001v9H475zm19.999 0H496v9h-1.001z"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    fill: "#e25950",
    x: 506,
    y: 85
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    fillRule: "evenodd",
    d: "M515.57 97.98l1.19-1.62-1.97-2.48 2.85-1.57 2.7.63.5-.87.64-3.09.83-.1.25-.44-1.95.04-.63 3.09-2.5-.87-.97-3.01h-1l-3 1-.5-.67h-.5l1 1.68 3-1.01.5 2.51-2.5 2.08.38 1.02 1.66 1.99.27.41-.46.7.21.58z"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.995 110A1.997 1.997 0 0010 112.005V115h21v-2.995A2.006 2.006 0 0029.005 110z",
    fill: "#f79a59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 115h21v5H10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 120v2.995A2.006 2.006 0 0011.995 125h17.01A1.997 1.997 0 0031 122.995V120z",
    fill: "#24b47e",
    "data-name": "Rectangle-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 119a1.5 1.5 0 111.5-1.5 1.502 1.502 0 01-1.5 1.5zm0-2a.5.5 0 10.5.5.5.5 0 00-.5-.5z",
    fill: "#6772e5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M10 115h1.001v5H10zm19.999 0H31v5h-1.001z"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.995 110A1.997 1.997 0 0041 112.005V115h21v-2.995A2.006 2.006 0 0060.005 110z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41 115h21v5H41z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M41 120v2.995A2.006 2.006 0 0042.995 125h17.01A1.997 1.997 0 0062 122.995V120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 116h1v3h-1zm2 0h1v3h-1zm2 0h1v3h-1z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M41 115h1.001v5H41zm19.999 0H62v5h-1.001z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M73.995 110A1.997 1.997 0 0072 112.005V115h21v-2.995A2.006 2.006 0 0091.005 110z",
    fill: "#24b47e"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M72 115h21v5H72z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M72 120v2.995A2.006 2.006 0 0073.995 125h17.01A1.997 1.997 0 0093 122.995V120z",
    fill: "#e25950"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 117.5,
    r: 1,
    fill: "none",
    stroke: "#e25950"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73 113.5a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-962",
    d: "M73 121.5a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M72 115h1.001v5H72zm19.999 0H93v5h-1.001z"
  })))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    fill: "#0172c6",
    x: 103,
    y: 110
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M124 116h-13.42v-6h-3v6H103v3h4.58v6h3v-6H124v-3z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#e25950",
    d: "M124 117h-14.42v-7h-1v7H103v1h5.58v7h1v-7H124v-1z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M140 110h9v15h-9v-15z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M140 125v-1h9v1zm0-15h9v1h-9z",
    fill: "#8898aa",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M136 110h5v15h-5a2 2 0 01-2-2v-11a2 2 0 012-2z",
    fill: "#24b47e"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M153 125h-5v-15h5a2 2 0 012 2v11a2 2 0 01-2 2z",
    fill: "#e25950"
  })))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    fill: "#f6f9fc",
    x: 165,
    y: 110
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M177 112.5c0 .83-1.5 2.5-1.5 2.5s-1.5-1.67-1.5-2.5a1.5 1.5 0 013 0z",
    fill: "#e25950"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M184 111a1 1 0 011 1v11a1 1 0 01-1 1h-17a1 1 0 01-1-1v-11a1 1 0 011-1h17m0-1h-17a2 2 0 00-2 2v11a2 2 0 002 2h17a2 2 0 002-2v-11a2 2 0 00-2-2z",
    fill: "#eaeef3"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M177.17 117.11l8.52-6.17A2 2 0 00184 110h-.42l-8.14 5.89L167 110a2 2 0 00-1.81 1.16l8.53 6-8.72 6.25a2 2 0 001.4 1.49l9-6.55 9.3 6.5a2 2 0 001.3-1.59z",
    fill: "#e25950"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.223 110.428a1.058 1.058 0 01-.091.068L206.5 116l-9.632-5.504a1.023 1.023 0 01-.091-.068A1.989 1.989 0 00196 112v1l8 4.5-8 4.5v1a1.989 1.989 0 00.777 1.572 1.023 1.023 0 01.091-.068L206.5 119l9.632 5.504a1.058 1.058 0 01.091.068A1.989 1.989 0 00217 123v-1l-8-4.5 8-4.5v-1a1.989 1.989 0 00-.777-1.572z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.5 116l9.632-5.504a1.058 1.058 0 00.091-.068A1.98 1.98 0 00215 110h-17a1.98 1.98 0 00-1.223.428 1.023 1.023 0 00.091.068zm0 3l-9.632 5.504a1.023 1.023 0 00-.091.068A1.98 1.98 0 00198 125h17a1.98 1.98 0 001.223-.428 1.058 1.058 0 00-.091-.068z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 113v9l8-4.5-8-4.5zm21 9v-9l-8 4.5 8 4.5z"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M227 115h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 112.005a2.006 2.006 0 00-1.995-2.005h-17.01a1.975 1.975 0 00-1.325.513.78.78 0 01.135.063L234 115h14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.675 124.485a1.975 1.975 0 001.32.515h17.01a1.997 1.997 0 001.995-2.005V120h-14l-6.194 4.424a.772.772 0 01-.131.06z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234 115l-6.194-4.424a.78.78 0 00-.135-.063 1.995 1.995 0 00-.671 1.493v10.99a1.996 1.996 0 00.675 1.49.772.772 0 00.131-.06L234 120l3.5-2.5z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 117.5,
    r: 1.5,
    fill: "#f6f9fc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M247 114.999h1v5h-1z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M260 110h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2v-11a2 2 0 012-2z",
    fill: "#f6f9fc"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M277 125h-17a2 2 0 01-2-2v-11a2 2 0 012-2h17a2 2 0 012 2v11a2 2 0 01-2 2zm1-13a1 1 0 00-1-1h-17a1 1 0 00-1 1v11a1 1 0 001 1h17a1 1 0 001-1z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M268.5 114a3.5 3.5 0 11-3.5 3.5 3.5 3.5 0 013.5-3.5z",
    fill: "#e25950"
  })))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289 114v7h21v-7h-21z",
    fill: "#F6F9FC"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.313 114H289v7h1.313v-7zm18.375 0v7H310v-7h-1.313z",
    fill: "#EAEEF3"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291 110a2 2 0 00-2 2v2h21v-2a2 2 0 00-2-2h-17z",
    fill: "#333"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289 115v5h21v-5h-21z",
    fill: "#E25950"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289 121v2a2 2 0 002 2h17a2 2 0 002-2v-2h-21z",
    fill: "#159570"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M300 112.172A7.657 7.657 0 01300 123a7.657 7.657 0 010-10.828z",
    fill: "#333"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M301.963 115.529a7.623 7.623 0 00-1.963-3.357 7.622 7.622 0 00-1.963 3.357c.586.457.963 1.17.963 1.971 0 .818-.393 1.545-1 2a7.62 7.62 0 002 3.5 7.622 7.622 0 002-3.5 2.496 2.496 0 01-1-2c0-.8.377-1.514.963-1.971z",
    fill: "#E25950"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 117.5,
    r: 0.5,
    fill: "#F6F9FC"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M300 112.172a2.707 2.707 0 010 3.828 2.707 2.707 0 010-3.828zm0 6.828a2.828 2.828 0 010 4 2.828 2.828 0 010-4z",
    fill: "#F6F9FC"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    ry: 2,
    fill: "#e25950",
    x: 320,
    y: 110
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5 121a.5.5 0 11.5-.5.5.5 0 01-.5.5zm-6-6a.5.5 0 11.5-.5.5.5 0 01-.5.5zm6 0a.5.5 0 11.5-.5.5.5 0 01-.5.5zm-6 6a.5.5 0 11.5-.5.5.5 0 01-.5.5zm3-7a.5.5 0 11.5-.5.5.5 0 01-.5.5zm-4 4a.5.5 0 11.5-.5.5.5 0 01-.5.5zm4 4a.5.5 0 11.5-.5.5.5 0 01-.5.5zm4-4a.5.5 0 11.5-.5.5.5 0 01-.5.5zm-4 2a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5z",
    fill: "#fedc32"
  })))), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M351 113.75h21v7.5h-21v-7.5z",
    fill: "#E25950"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351 112.5v1.25h21v-1.25c0-1.38-1.175-2.5-2.625-2.5h-15.75c-1.45 0-2.625 1.12-2.625 2.5zm2.625 12.5h15.75c1.45 0 2.625-1.12 2.625-2.5v-1.25h-21v1.25c0 1.38 1.175 2.5 2.625 2.5z",
    fill: "#43458B"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.875 115h-2.625v1.25h2.625V115zm7.875 2.5h-10.5v2.5h10.5v-2.5zm-6.563-2.5h2.626v1.25h-2.626V115zm6.563 0h-2.625v1.25h2.625V115z",
    fill: "#fff"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 3,
    ry: 3,
    fill: "#fcd669",
    x: 382,
    y: 110
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.5,
    y: 110.5,
    width: 20,
    height: 14,
    rx: 3,
    ry: 3,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 113l-18 12h-2.001a.998.998 0 01-.999-1.008V122l18-12h2.001a.998.998 0 01.999 1.008z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-87",
    d: "M383.992 110a1.99 1.99 0 00-1.992 2v8l15-10z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-87",
    d: "M403 123a1.997 1.997 0 01-1.992 2H388l15-10z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.5,
    cy: 119.5,
    r: 1.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.5,
    cy: 115.5,
    r: 1.5,
    fill: "#fff"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M413 113h21v9h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.493 110a1.493 1.493 0 00-1.493 1.5v1.5h21v-1.5a1.5 1.5 0 00-1.493-1.5z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e25950",
    d: "M413 114h21v7h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M413 122v1.5a1.5 1.5 0 001.493 1.5h18.014a1.493 1.493 0 001.493-1.5V122z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.5 119a1.5 1.5 0 10-1.5-1.5 1.5 1.5 0 001.5 1.5z",
    fill: "#fff"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446 110h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2v-11a2 2 0 012-2z",
    fill: "#f6f9fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.995 110h17.01a2 2 0 011.995 1.992v11.016a1.994 1.994 0 01-1.995 1.992h-17.01a2 2 0 01-1.995-1.992v-11.016a1.994 1.994 0 011.995-1.992zm0 1a.997.997 0 00-.995.998v11.004a1 1 0 00.995.998h17.01a.997.997 0 00.995-.998v-11.004a1 1 0 00-.995-.998z",
    fill: "#dfe5eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 117.5a3.5 3.5 0 116.663 1.5h-6.326a3.486 3.486 0 01-.337-1.5z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458 113.207V113h1.207l1.293 1.793V115h-1.207zm-9.5 1.586l1.293-1.793H451v.207L449.707 115H448.5zm9.5 7l1.293-1.793h1.207v.207L459.207 122H458zm-9.5-1.586V120h1.207l1.293 1.793V122h-1.207z",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.175 116.736a1.733 1.733 0 011.773 1.37 3.501 3.501 0 01-3.378 2.893 3.668 3.668 0 01-3.163-1.86 3.485 3.485 0 01-.407-1.609 3.28 3.28 0 01.392-1.53c.002.047.004.098.004.154 0 .674-.003 2.084 1.692 2.084s1.646-1.502 3.087-1.502z",
    fill: "#43458b"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477 110v5h19v-2.995a1.999 1.999 0 00-1.997-2.005z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M476 115h20v5h-20z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M477 120v5h17.003a1.999 1.999 0 001.997-2.005V120z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 115v5l-5.995 5a1.996 1.996 0 01-2.005-1.992v-11.016a2 2 0 012.005-1.992z",
    "data-name": "Rectangle-295"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M494.999 115H496v5h-1.001z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    ry: 2,
    fill: "#1cafc8",
    x: 506,
    y: 110
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 516.5,
    cy: 117.5,
    r: 3.5,
    fill: "#fcd669"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#047a9d",
    fillOpacity: 0.199,
    opacity: 0.78,
    style: {
      isolation: "isolate"
    },
    d: "M507 113h4v9h-4z"
  }), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M508 114h2v1h-2zm0 2h2v1h-2zm0 2h2v1h-2zm0 2h2v1h-2z",
    fill: "#fcd669"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.995 135A1.992 1.992 0 0010 137v2h21v-2a2.003 2.003 0 00-1.995-2z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43458b",
    d: "M10 139h21v7H10z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M10 146v2a2.003 2.003 0 001.995 2h17.01A1.992 1.992 0 0031 148v-2z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 142.5,
    r: 1.5,
    fill: "#fff"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.995 135A1.992 1.992 0 0041 137v2h21v-2a2.003 2.003 0 00-1.995-2z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M41 139h21v7H41z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M41 146v2a2.003 2.003 0 001.995 2h17.01A1.992 1.992 0 0062 148v-2z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 144v1h-1v-1h-2l2.5-4 2.5 4z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M41 139h1.001v7H41zm19.999 0H62v7h-1.001z"
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    ry: 2,
    fill: "#45b2e8",
    x: 72,
    y: 135
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M82.5 137L77 148h11l-5.5-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5 140l-4 8h8l-4-8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-1065",
    fill: "#fcd669",
    d: "M82.5 143.8L77 148h11l-5.5-4.2z"
  })))), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M105 135a2 2 0 00-2 2v6h21v-6a2 2 0 00-2-2z",
    fill: "#555abf"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M103 143v5a2 2 0 002 2h17a2 2 0 002-2v-5z",
    fill: "#e25950"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M109.44 140.74h-.07v-.38a1.26 1.26 0 00.54-1 1.29 1.29 0 00-1.77-1.23.39.39 0 00-.14-.41l-.07-.24.28.08V137l-.28.08.07-.26h-.52l.08.28-.28-.1v.54l.28-.08-.07.24a.43.43 0 00-.13.41 1.29 1.29 0 00-1.77 1.21 1.26 1.26 0 00.54 1v.38h-.07a.2.2 0 000 .4h3.38a.2.2 0 000-.4z",
    fill: "#fcd669"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M136.625 135h15.75c1.45 0 2.625 1.12 2.625 2.5v10c0 1.38-1.175 2.5-2.625 2.5h-15.75c-1.45 0-2.625-1.12-2.625-2.5v-10c0-1.38 1.175-2.5 2.625-2.5z",
    fill: "#F4B32E"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#E37C4C",
    d: "M137.938 136.25h2.625v12.5h-2.625z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.688 136.25h-10.814v12.5h10.813a1 1 0 001-1v-10.5a1 1 0 00-1-1zm-8.188 1.25h-1.313v1.25h1.313v-1.25zm6.563 0h1.312v1.25h-1.313v-1.25zm-6.563 8.75h-1.313v1.25h1.313v-1.25zm6.563 0h1.312v1.25h-1.313v-1.25zm0-5H144.5v2.5h6.563v-2.5z",
    fill: "#B1372F"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.995 135a1.997 1.997 0 00-1.995 2.005V140h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
    fill: "#555abf"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M165 140h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M165 145v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V145z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5 141l-1.856 2.227c-.356.427-.2.773.356.773h3c.552 0 .713-.344.356-.773z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M165 140h1.001v5H165zm19.999 0H186v5h-1.001z"
  })))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M198 135a2 2 0 00-2 2v3h21v-3a2 2 0 00-2-2z",
    fill: "#fcd669"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#24b47e",
    d: "M196 140h21v5h-21z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M196 145v3a2 2 0 002 2h17a2 2 0 002-2v-3z",
    fill: "#e25950"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M227 139h21v7h-21v-7z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M247 146v-7h1v7zm-20-7h1v7h-1z",
    fill: "#8898aa",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M227 148v-3h21v3a2 2 0 01-2 2h-17a2 2 0 01-2-2z",
    fill: "#45b2e8"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M248 137v3h-21v-3a2 2 0 012-2h17a2 2 0 012 2z",
    fill: "#e25950"
  })))), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M259.995 135a1.992 1.992 0 00-1.995 2v4h21v-4a2 2 0 00-1.995-2z",
    fill: "#b1372f"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8fafc",
    d: "M258 141h21v3h-21z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M258 144v4a2 2 0 001.995 2h17.01a1.992 1.992 0 001.995-2v-4z",
    fill: "#b1372f"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M258 141h1.001v3H258zm19.999 0H279v3h-1.001z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    fill: "#e25950",
    x: 289,
    y: 135
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#24b47e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M299.5 137.5l3 9-8-6h10l-8 6 3-9z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320 143v5a2 2 0 002 2h17a2 2 0 002-2v-5h-21z",
    fill: "#F6F9FC"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322 135a2 2 0 00-2 2v6h21v-6a2 2 0 00-2-2h-17z",
    fill: "#E25950"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M339 150h-17a2 2 0 01-2-2v-5h1v5a1 1 0 001 1h17a1 1 0 001-1v-5h1v5a2 2 0 01-2 2z",
    fill: "#EAEEF3"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353 135a2 2 0 00-2 2v11a2 2 0 002 2h4.563v-15H353z",
    fill: "#43458B"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.438 135v15H370a2 2 0 002-2v-11a2 2 0 00-2-2h-4.563z",
    fill: "#E25950"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.563 135v15h7.875v-15h-7.877z",
    fill: "#FCD669"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.438 135h-7.877v1.25h7.875V135zm-7.877 13.75V150h7.875v-1.25h-7.872z",
    fill: "#A68527",
    fillOpacity: 0.1
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.875 140h5.25v3.125c0 1.38-1.175 2.5-2.625 2.5s-2.625-1.12-2.625-2.5V140z",
    fill: "#E25950"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.5 145.625c-1.45 0-2.625-1.12-2.625-2.5v-.625h5.25v.625c0 1.38-1.175 2.5-2.625 2.5z",
    fill: "#45B2E8"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.188 141.25h2.624l-1.312 2.5-1.313-2.5z",
    fill: "#FCD669"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M384.006 135a2 2 0 00-2.006 1.992v11.016a1.992 1.992 0 002.006 1.992H389v-15z",
    fill: "#f6f9fc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384 136a1 1 0 00-1 1v11a1 1 0 001 1h9v1h-9a2 2 0 01-2-2v-11a2 2 0 012-2h9v1z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-87",
    d: "M401.14 135a2.1 2.1 0 011.86 2.276V143h-14v-8z",
    fill: "#e25950"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-87",
    d: "M403 148.257a1.805 1.805 0 01-1.86 1.743H389v-7h14z",
    fill: "#24b47e"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    ry: 2,
    fill: "#fcd669",
    x: 413,
    y: 135
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 141.143l1-.143v-3.757l-1 .382-6.497 2.477-.47-.883L430.61 136l1.418-.997c-.011 0-.019-.003-.028-.003h-7l-.25 1-.75 3h-1l-.75-3-.25-1h-6.962l1.422 1 4.576 3.22-.47.882-6.566-2.504-.967-.368-.03-.259c0 .01-.003.019-.003.029v4l1 .143 6 .857v1l-6 .857-1 .143v4c0 .03.008.059.009.09l.024-.236.967-.37 6.566-2.503.47.883-4.457 3.136-1.422 1H422l.25-1 .75-3h1l.75 3 .25 1h6.913l-1.421-1-4.459-3.136.47-.883 6.497 2.477 1 .382V144l-1-.143-6-.857v-1zM423.5 145a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5z",
    fill: "#e25950"
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.006 135a2 2 0 00-2.006 1.992v11.016a1.992 1.992 0 002.006 1.992H451v-15z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458 135v15h4.994a2 2 0 002.006-1.992v-11.016a1.992 1.992 0 00-2.006-1.992z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-295",
    fill: "#fcd669",
    d: "M451 135h7v15h-7z"
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.995 135a1.997 1.997 0 00-1.995 2.005V140h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24b47e",
    d: "M475 140h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M475 145v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V145z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.633 141l-2.625.006a.364.364 0 01-.347-.253l-.813-2.497a.364.364 0 00-.695 0l-.811 2.496a.364.364 0 01-.347.253h-2.626a.364.364 0 00-.215.661l2.124 1.544a.364.364 0 01.132.409l-.81 2.497a.364.364 0 00.562.41l2.124-1.426a.364.364 0 01.43 0l2.125 1.425a.364.364 0 00.563-.409l-.813-2.497a.364.364 0 01.132-.41l2.125-1.543a.364.364 0 00.134-.409.37.37 0 00-.35-.257z",
    fill: "#fff"
  })))), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508 135a2 2 0 00-2 2v11a2 2 0 002 2h5v-15h-5zm17 0a2 2 0 012 2v11a2 2 0 01-2 2h-5v-15h5z",
    fill: "#E25950"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M509.5 141.375a1.688 1.688 0 100-3.375 1.688 1.688 0 000 3.375zm-1.688 1.125h1.125v4.5h-1.124v-4.5zm3.375 0h-1.124v4.5h1.125v-4.5z",
    fill: "#FCD669"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513 135h7v15h-7v-15z",
    fill: "#45B2E8"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 160a2 2 0 00-2 2v11a2 2 0 002 2h17a2 2 0 002-2v-11a2 2 0 00-2-2H12z",
    fill: "#159570"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.716 168.941a2.092 2.092 0 01-.2-.896c0-.743.389-1.4.984-1.795.595.395.984 1.052.984 1.795 0 .29-.059.568-.167.82.232-.074.481-.115.74-.115.78 0 1.47.37 1.885.938a2.329 2.329 0 01-1.885.937 2.348 2.348 0 01-1.64-.657 2.347 2.347 0 01-1.641.657c-.78 0-1.47-.37-1.885-.938a2.33 2.33 0 011.885-.937c.335 0 .653.068.94.191z",
    fill: "#fff"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.844 165c0-.345.28-.625.625-.625h.062a.625.625 0 110 1.25h-.062a.625.625 0 01-.625-.625zm-1.344 0a.625.625 0 100 1.25h.063a.625.625 0 100-1.25H18.5zm-1.313 1.25a.625.625 0 100 1.25h.063a.625.625 0 100-1.25h-.063zm5.251-1.25a.625.625 0 100 1.25h.063a.625.625 0 100-1.25h-.063zm.688 1.875c0-.345.28-.625.625-.625h.063a.625.625 0 110 1.25h-.063a.625.625 0 01-.625-.625z",
    fill: "#FCD669"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42 161h9v13h-9z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEFF4",
    d: "M60 175H43a2 2 0 01-2-2v-11a2 2 0 012-2h17a2 2 0 012 2v11a2 2 0 01-2 2zm1-13a1 1 0 00-1-1H43a1 1 0 00-1 1v11a1 1 0 001 1h17a1 1 0 001-1v-11z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#E25950",
    d: "M51 160v15h9a2 2 0 002-2v-11a2 2 0 00-2-2h-9z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#9C9B9A",
    d: "M45.13 167.88v-2h-2v-1.75h2v-2h1.75v2h2v1.75h-2v2h-1.75z",
    opacity: 0.5
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#E25950",
    d: "M46.75 162.25v2h2v1.5h-2v2h-1.5v-2h-2v-1.5h2v-2h1.5zM47 162h-2v2h-2v2h2v2h2v-2h2v-2h-2v-2z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.617 160h15.766c1.443 0 2.617 1.12 2.617 2.501v1.249H72v-1.249c0-1.376 1.172-2.501 2.617-2.501z",
    fill: "#E25950"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 167.5h21v3.75H72v-3.75z",
    fill: "#FCD669"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 163.75h21v3.75H72v-3.75z",
    fill: "#43458B"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.313 167.5H72v3.75h1.313v-3.75zm18.375 0v3.75H93v-3.75h-1.313z",
    fill: "#A68527",
    fillOpacity: 0.1
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 171.25h21v1.25c0 1.39-1.172 2.5-2.617 2.5H74.617c-1.443 0-2.617-1.12-2.617-2.5v-1.25z",
    fill: "#24B47E"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M109 160h9v15h-9v-15z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M109 175v-1h9v1zm0-15h9v1h-9z",
    fill: "#8898aa",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M105 160h5v15h-5a2 2 0 01-2-2v-11a2 2 0 012-2z",
    fill: "#24b47e"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M122 175h-5v-15h5a2 2 0 012 2v11a2 2 0 01-2 2z",
    fill: "#e25950"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M111.575 168a1.913 1.913 0 003.827 0h.852l.002.014a2.753 2.753 0 11-5.505 0l.002-.014z",
    fill: "#24b47e"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M113.5 166a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5z",
    fill: "#b5562b"
  })))), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M153 175h-17a2 2 0 01-2-2v-7h8v-6h11a2 2 0 012 2v11a2 2 0 01-2 2z",
    fill: "#e25950"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M134 171h21v1h-21zm0-2h21v1h-21zm0-2h21v1h-21zm8-2h13v1h-13zm0-2h13v1h-13zm0-2h12.72a2 2 0 01.28 1h-13zm12.72 13h-20.44a2 2 0 01-.28-1h21a2 2 0 01-.28 1z",
    fill: "#f6f9fc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153 175h-17a2 2 0 01-2-2v-7h1v7a1 1 0 001 1h17a1 1 0 001-1v-11a1 1 0 00-1-1h-11v-1h11a2 2 0 012 2v11a2 2 0 01-2 2z",
    style: {
      isolation: "isolate"
    },
    fill: "#e25950",
    opacity: 0.2
  }), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M144 160h-8a2 2 0 00-2 2v8h10z",
    fill: "#555abf"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 167.75a2.75 2.75 0 111.84-4.75 3.5 3.5 0 10-2.84 5.5 3.46 3.46 0 002.84-1.5 2.73 2.73 0 01-1.84.75z",
    fill: "#fcd669"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.5,
    cy: 165,
    r: 1,
    fill: "#fcd669"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171 160v15h13a2 2 0 002-2v-11a2 2 0 00-2-2h-13z",
    fill: "#F6F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 160a2 2 0 00-2 2v11a2 2 0 002 2h8v-15h-8z",
    fill: "#24B47E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 163v1a3.54 3.54 0 00-2.148 5.805A3.54 3.54 0 00175 171v1a4.05 4.05 0 01-.5 0 4.5 4.5 0 110-9c.167-.01.333-.01.5 0z",
    fill: "#E25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.48 165.4a3.62 3.62 0 00-2.88-1.4 3.55 3.55 0 00-3.6 3.5 3.55 3.55 0 003.6 3.5 3.62 3.62 0 002.88-1.4 4.5 4.5 0 110-4.2z",
    fill: "#E25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5 169a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "#E25950"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M184 161a1 1 0 011 1v11a1 1 0 01-1 1h-9v1h9a2 2 0 002-2v-11a2 2 0 00-2-2h-9v1h9z",
    fill: "#8898AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167 160a2 2 0 00-2 2v11a2 2 0 002 2h17a2 2 0 002-2v-11a2 2 0 00-2-2h-17z",
    fill: "#159570"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165 171v2a2 2 0 002 2h17a2 2 0 002-2v-2h-21z",
    fill: "#FCD669"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165 171v2a2 2 0 002 2h17a2 2 0 002-2v-2h-21z",
    fill: "#FCD669"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165 171v2a2 2 0 002 2h17a2 2 0 002-2v-2h-21z",
    fill: "#FCD669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 172v1a1 1 0 001 1h17a1 1 0 001-1v-2h1v2a2 2 0 01-2 2h-17a2 2 0 01-2-2v-2h1v1z",
    fill: "#A68527",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165 165v-1h21v1h-21zm0 6v-1h21v1h-21z",
    fill: "#F6F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185 164v1h1v-1h-1zm0 6v1h1v-1h-1z",
    fill: "#EAEEF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165 165v5h21v-5h-21z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 165l-6.19-4.42a.91.91 0 00-.14-.07A2 2 0 00165 162v11a2 2 0 00.67 1.48.42.42 0 00.14-.06L172 170l3.5-2.5-3.5-2.5z",
    fill: "#E25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.934 166.628l-1.424.002a.198.198 0 01-.189-.137l-.44-1.355a.198.198 0 00-.378 0l-.44 1.354a.197.197 0 01-.188.137h-1.425a.198.198 0 00-.116.36l1.152.837c.07.05.099.14.072.221l-.44 1.356a.198.198 0 00.305.221l1.152-.773c.07-.05.164-.05.234 0l1.152.773a.198.198 0 00.306-.221l-.441-1.356a.198.198 0 01.072-.221l1.152-.838a.2.2 0 00-.117-.361z",
    fill: "#FCD669"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M199 175h3l15-10v-2l-18 12zm12-15l-15 10v2l18-12h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 160l-18 12a3 3 0 003 3l18-12a3 3 0 00-3-3z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 160a3 3 0 00-3 3v7l15-10zm-1 4v-2h2v2z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 175a3 3 0 003-3v-7l-15 10z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd669",
    d: "M198 162h2v2h-2z"
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.995 160a1.997 1.997 0 00-1.995 2.005V165h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M227 165h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M227 170v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V170z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 167.5,
    r: 1.5,
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M227 165h1.001v5H227zm19.999 0H248v5h-1.001z"
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.006 160a2 2 0 00-2.006 1.992v11.016a1.992 1.992 0 002.006 1.992H265v-15zM272 160v15h4.994a2 2 0 002.006-1.992v-11.016a1.992 1.992 0 00-2.006-1.992z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M265 160h7v15h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M265 175v-1.001h7v1zm0-14v-1h7v1z"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.995 160a1.997 1.997 0 00-1.995 2.005V165h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M289 165h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 170v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V170z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.5 169a1.5 1.5 0 111.5-1.5 1.502 1.502 0 01-1.5 1.5zm0-2a.5.5 0 10.5.5.5.5 0 00-.5-.5z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M289 165h1.001v5H289zm19.999 0H310v5h-1.001z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M320 164h21v7h-21v-7z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M340 171v-7h1v7zm-20-7h1v7h-1z",
    fill: "#8898aa",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M341 162v3h-21v-3a2 2 0 012-2h17a2 2 0 012 2z",
    fill: "#e25950"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M320 173v-3h21v3a2 2 0 01-2 2h-17a2 2 0 01-2-2z",
    fill: "#6772e5"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M353 160h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2v-11a2 2 0 012-2z",
    fill: "#e25950"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    fill: "#f6f9fc",
    d: "M372 169h-12v6h-3v-6h-6v-3h6v-6h3v6h12v3z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M371 169v-3h1v3zm-14 5h3v1h-3zm0-14h3v1h-3zm-6 6h1v3h-1z",
    fill: "#555abf",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    fill: "#555abf",
    d: "M372 168h-13v7h-1v-7h-7v-1h7v-7h1v7h13v1z"
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384 160h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2v-11a2 2 0 012-2z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M382 165.664l3.498-2.4.001-.001h.001l.001.001 5.425 3.722h-1.767l-3.659-2.51-3.5 2.401zm9-5.569v1.213l-3.499 2.4-.001.001-.001-.001-4.758-3.264a1.983 1.983 0 011.121-.444l3.638 2.496z",
    fill: "#f6f9fc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M390.909 167l-3.659-2.51-3.659 2.51H382v-.121l5.249-3.601v-.001h.002v.001L391 165.85V167zm-5.158-3.278v.001h-.002v-.001l-3.601-2.47a1.99 1.99 0 01.601-.801l3.001 2.059 3.659-2.51H391v.121z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    fill: "#f6f9fc",
    d: "M391 164.625h-3.375V167h-2.25v-2.375H382v-2.25h3.375V160h2.25v2.375H391v2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    fill: "#e25950",
    d: "M391 163.998h-4V167h-1v-3.002h-4v-.996h4V160h1v3.002h4v.996z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M398.22 166.44a1.22 1.22 0 111.186-1.22 1.22 1.22 0 01-1.185 1.22zm-2-2a1.22 1.22 0 111.186-1.22 1.22 1.22 0 01-1.186 1.22zm-.78 1.781a1.22 1.22 0 11-1.22-1.186 1.22 1.22 0 011.22 1.186zm.78 3.781a1.22 1.22 0 11-1.185 1.22 1.22 1.22 0 011.185-1.22z",
    fill: "#f6f9fc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M398.188 165.874a.687.687 0 11.686-.688.687.687 0 01-.686.688zm-2 6.001a.688.688 0 11.687-.688.688.688 0 01-.688.688zm0-8.001a.687.687 0 11.685-.688.687.687 0 01-.685.688zm-2 3a.688.688 0 11.617-.336.688.688 0 01-.617.336z",
    fill: "#e25950"
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417 160v6h17v-4.002a1.996 1.996 0 00-2-1.998z",
    fill: "#f6f9fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.5 167.5v-5.502a1.502 1.502 0 00-1.495-1.498h-17.01",
    fill: "none",
    stroke: "#eaeef3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418 165v-5h-2.995a2 2 0 00-2.005 1.992v11.016a1.996 1.996 0 002.005 1.992H418v-5h16v-5z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418 170v5h14.006a1.997 1.997 0 001.994-2.005V170z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.5 162a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
    fill: "#fff"
  })))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.992 160a1.99 1.99 0 00-1.992 1.998V168h11v-8z",
    fill: "#f7fafc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.5 167.5h10v-7h-8.508a1.49 1.49 0 00-1.492 1.498z",
    fill: "none",
    stroke: "#e6e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 167v8h9.008a1.99 1.99 0 001.992-1.998V167z",
    fill: "#f7fafc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.5 167.5v7h8.508a1.49 1.49 0 001.492-1.498V167.5z",
    fill: "none",
    stroke: "#e6e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.792 170.318l-1.153.002a.16.16 0 01-.152-.11l-.357-1.098a.16.16 0 00-.305 0l-.357 1.097a.16.16 0 01-.152.11h-1.154a.16.16 0 00-.094.29l.933.679a.16.16 0 01.058.18l-.356 1.097a.16.16 0 00.247.18l.933-.626a.16.16 0 01.188 0l.934.626a.16.16 0 00.247-.18l-.357-1.097a.16.16 0 01.058-.18l.933-.678a.16.16 0 00.06-.18.163.163 0 00-.154-.112z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.747 163.347l-1.14.002a.158.158 0 01-.15-.11l-.353-1.084a.158.158 0 00-.302 0l-.351 1.085a.158.158 0 01-.151.11h-1.14a.158.158 0 00-.093.287l.921.67a.158.158 0 01.058.178l-.352 1.084a.158.158 0 00.245.177l.921-.619a.158.158 0 01.186 0l.923.619a.158.158 0 00.244-.177l-.353-1.086a.158.158 0 01.058-.178l.922-.67a.158.158 0 00.058-.178.16.16 0 00-.15-.111zM444 168v4.994a2.004 2.004 0 001.992 2.006H455v-7z",
    fill: "#217ab7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M454 160v8h11v-6.002a2 2 0 00-1.992-1.998z",
    fill: "#e25950"
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.006 160a2 2 0 00-2.006 1.992v11.016a1.992 1.992 0 002.006 1.992H482v-15zM489 160v15h4.994a2 2 0 002.006-1.992v-11.016a1.992 1.992 0 00-2.006-1.992z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M482 160h7v15h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M482 175v-1.001h7v1zm0-14v-1h7v1z"
  })))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527 161.992a2 2 0 00-1.995-1.992h-17.01a1.979 1.979 0 00-1.302.495l19.615 14.01a1.978 1.978 0 00.692-1.497z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.693 160.495a1.978 1.978 0 00-.693 1.497v11.016a2 2 0 001.995 1.992h17.01a1.979 1.979 0 001.303-.495z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.5 168a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
    fill: "#fff",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.5 170a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
    fill: "#fff",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.5 169a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
    fill: "#fff",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "path-121",
    d: "M510.5 172a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
    fill: "#fff",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.5 166a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521 164v-1.292c0-.557.353-.75.804-.418l2.892 2.12c.444.326.356.59-.195.59H522v1.506c0 .536-.35.721-.784.384l-2.932-2.28c-.43-.335-.337-.61.215-.61z",
    fill: "#fac92e"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M11.418 185.096L21 192.5l-9.582 7.404A1.994 1.994 0 0110 198v-11a1.994 1.994 0 011.418-1.904z",
    fill: "#f6f9fc"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M12 186a1 1 0 00-1 1v11a1 1 0 001 1h1v1h-1a2 2 0 01-2-2v-11a2 2 0 012-2h1v1z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M29 200H12a1.982 1.982 0 01-1.291-.484L21 192.5l-.733-.5H31v6a2 2 0 01-2 2z",
    fill: "#e25950"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M10.709 185.484A1.982 1.982 0 0112 185h17a2 2 0 012 2v5.5H21z",
    fill: "#555abf"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M14.507 190a2.502 2.502 0 11-2.493 2.5 2.496 2.496 0 012.493-2.5z",
    fill: "#f5be58"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M43 185h17a2 2 0 012 2v11a2 2 0 01-2 2H43a2 2 0 01-2-2v-11a2 2 0 012-2z",
    fill: "#f6f9fc"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M60 200H43a2 2 0 01-2-2v-11a2 2 0 012-2h17a2 2 0 012 2v11a2 2 0 01-2 2zm1-13a1 1 0 00-1-1H43a1 1 0 00-1 1v11a1 1 0 001 1h17a1 1 0 001-1z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M47 185v15h13.008A1.993 1.993 0 0062 198.008v-11.016A1.993 1.993 0 0060.008 185z",
    fill: "#24b47e"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M53.937 187a4.206 4.206 0 00-2.071 3.566 4.488 4.488 0 004.664 4.29 4.946 4.946 0 002.47-.65A4.73 4.73 0 0154.747 197 4.898 4.898 0 0150 191.963 4.962 4.962 0 0153.937 187z",
    fill: "#fff"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 190,
    r: 1,
    fill: "#fff"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M73 185.89h19v6.354H73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5 192.5h20v-5.502a1.502 1.502 0 00-1.495-1.498h-17.01a1.491 1.491 0 00-1.495 1.498z",
    fill: "none",
    stroke: "#dfe5eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 192v6.002A2.002 2.002 0 0073.995 200h17.01A1.991 1.991 0 0093 198.002V192z",
    fill: "#e25950"
  })))), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M105 185a2 2 0 00-2 2v3h21v-3a2 2 0 00-2-2z",
    fill: "#e25950"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M103 190h21v5h-21z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M123 190h1v5h-1z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M103 195v3a2 2 0 002 2h17a2 2 0 002-2v-3z",
    fill: "#e25950"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M105 200l8-7.5-8-7.5a2 2 0 00-2 2v11a2 2 0 002 2z",
    fill: "#555abf"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M106.5 190.29l.65 1.32 1.45.21-1.05 1.02.25 1.45-1.3-.68-1.3.68.25-1.45-1.05-1.02 1.45-.21.65-1.32z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M136 185a2 2 0 00-2 2v3h21v-3a2 2 0 00-2-2z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M134 190h21v5h-21z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M154 190h1v5h-1z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M134 195v3a2 2 0 002 2h17a2 2 0 002-2v-3z",
    fill: "#0a9362"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M136 200l8-7.5-8-7.5a2 2 0 00-2 2v11a2 2 0 002 2z",
    fill: "#e25950"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173 200h-6a2 2 0 01-2-2v-11a2 2 0 012-2h6z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 200h-12v-15h12a2 2 0 012 2v11a2 2 0 01-2 2z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.003 192.5a3.531 3.531 0 100 .001z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.425 190.001a2.5 2.5 0 11-2.424 2.574L169 192.5a2.5 2.5 0 012.425-2.499z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5 191h2v2.031a1 1 0 01-2 0z",
    fill: "#f6f9fc"
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.995 185a1.997 1.997 0 00-1.995 2.005V190h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M196 190h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 195v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V195z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.5 194a1.5 1.5 0 111.5-1.5 1.502 1.502 0 01-1.5 1.5zm0-2a.5.5 0 10.5.5.5.5 0 00-.5-.5z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M196 190h1.001v5H196zm19.999 0H217v5h-1.001z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M229 185h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2v-11a2 2 0 012-2z",
    fill: "#f6f9fc"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M246 200h-17a2 2 0 01-2-2v-11a2 2 0 012-2h17a2 2 0 012 2v11a2 2 0 01-2 2zm1-13a1 1 0 00-1-1h-17a1 1 0 00-1 1v11a1 1 0 001 1h17a1 1 0 001-1z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M236 200h-2l-1-.5 2-1-2-1 2-1-2-1 2-1-2-1 2-1-2-1 2-1-2-1 2-1-2-1 2-1-2-1 1-.5h11.991a2.002 2.002 0 012.009 1.992v11.016a2.001 2.001 0 01-2.009 1.992z",
    fill: "#b1372f"
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6772E5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277 200h-15.567l6.957-15H277a2 2 0 012 2v11a2 2 0 01-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.438 200H260a2 2 0 01-2-2v-11a2 2 0 012-2h11.098l-8.66 15z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M265 196l6.856-1.453V189L265 190.453z"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.006 185a2 2 0 00-2.006 1.992v11.016a1.992 1.992 0 002.006 1.992H296v-15z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 185v15h4.994a2 2 0 002.006-1.992v-11.016a1.992 1.992 0 00-2.006-1.992z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-295",
    fill: "#fcd669",
    d: "M296 185h7v15h-7z"
  })))), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M322 185a2 2 0 00-2 2v3h21v-3a2 2 0 00-2-2h-17z",
    fill: "#E25950"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M341 190h-21v5h21v-5z",
    fill: "#43458B"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M320 195v3a2 2 0 002 2h17a2 2 0 002-2v-3h-21z",
    fill: "#F6F9FC"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M330 188h-7v5.5a3.5 3.5 0 007 0V188z",
    fill: "#E25950"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M322 199a1 1 0 01-1-1v-3h-1v3a2 2 0 002 2h17a2 2 0 002-2v-3h-1v3a1 1 0 01-1 1h-17z",
    fill: "#EAEEF3"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M324 190h5v4l-2 1-.5 1-.5-1-2-1v-4z",
    fill: "#F6F9FC"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M326 193v1c-.8 0-1-.667-1-1h1z",
    fill: "#fff"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M326 193v1c-.8 0-1-.667-1-1h1z",
    fill: "#E25950"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M327 193h1c0 .8-.667 1-1 1v-1z",
    fill: "#fff"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M327 193h1c0 .8-.667 1-1 1v-1z",
    fill: "#E25950"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M325 191h1v1h-1v-1z",
    fill: "#fff"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M325 191h1v1h-1v-1z",
    fill: "#E25950"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M328 191h-1v1h1v-1z",
    fill: "#fff"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M328 191h-1v1h1v-1z",
    fill: "#E25950"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 325.5,
    cy: 189.5,
    r: 0.5,
    fill: "#F6F9FC"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.5,
    cy: 189.5,
    r: 0.5,
    fill: "#F6F9FC"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M328 189v1l1-.5-1-.5zm-3 1v-1l-1 .5 1 .5zm-1-2h5v1h-5z",
    fill: "#E9C152"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.995 185a1.999 1.999 0 00-1.995 1.998V191h21v-4.002a2.002 2.002 0 00-1.995-1.998z",
    fill: "#f6f9fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.5 190.5h20v-3.502a1.502 1.502 0 00-1.495-1.498h-17.01a1.499 1.499 0 00-1.495 1.498z",
    fill: "none",
    stroke: "#dfe5eb"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43458b",
    d: "M351 190h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M351 195v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V195z",
    fill: "#e25950"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.995 185a1.993 1.993 0 00-1.995 2.006V192h21v-4.994a2.006 2.006 0 00-1.995-2.006z",
    fill: "#45b2e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd669",
    d: "M382 192h21v4h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M382 196v2a2.003 2.003 0 001.995 2h17.01a1.992 1.992 0 001.995-2v-2z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.5,
    cy: 188.5,
    r: 1.5,
    fill: "#fcd669"
  })))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    ry: 2,
    fill: "#24b47e",
    x: 413,
    y: 185
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428 195h1l-.5 1h-.5v1l-1-.5v-.5h-6.508L418 195h9v-.5l1-.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-584",
    fill: "#fff",
    d: "M427 189l1.657.146.343.854v2h-1l-1.492-.528L426 192v-3h1zm-3.283.375L425 189v3l-1.283-.488L422 192l.172-1.858L422 189l1.717.375zM420 189l1 1v2l-.764-.343L419 192l-.994-.006.183-2.917L420 189z"
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446 185h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2v-11a2 2 0 012-2z",
    fill: "#217ab7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    fill: "#fcd669",
    d: "M465 194h-12v6h-3v-6h-6v-3h6v-6h3v6h12v3z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M476.995 185a1.991 1.991 0 00-1.995 1.998V193h21v-6.002a2.002 2.002 0 00-1.995-1.998z",
    fill: "#ea2c3f"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M496 192v6a2 2 0 01-2 2h-17a2 2 0 01-2-2v-6z",
    fill: "#f6f9fc"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M494 200h-17a2 2 0 01-2-2v-6h1v6a1 1 0 001 1h17a1 1 0 001-1v-6h1v6a2 2 0 01-2 2z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M475 193v-6a2 2 0 012-2h17a2 2 0 012 2v6z",
    fill: "#e25950"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M479.368 188.96a2.367 2.367 0 002.354 2.367A2.956 2.956 0 11479.96 186a2.936 2.936 0 011.762.593 2.367 2.367 0 00-2.354 2.367zm6.194.415a.594.594 0 11.57-.593.594.594 0 01-.57.593zm-1.5-1.187a.594.594 0 11.595-.593.594.594 0 01-.595.593zm-.281 2.375a.594.594 0 11-.594-.594.594.594 0 01.594.594zm-1.187-1.188a.594.594 0 11.594-.594.594.594 0 01-.594.594zm2.375.594a.593.593 0 11-.593.593.593.593 0 01.593-.593z",
    fill: "#f6f9fc"
  })))), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M508 185a2 2 0 00-2 2v3h21v-3a2 2 0 00-2-2z",
    fill: "#f6f9fc"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "#555abf",
    d: "M506 190h21v5h-21z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M506 195v3a2 2 0 002 2h17a2 2 0 002-2v-3z",
    fill: "#e25950"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M515 189v4.5a2.5 2.5 0 01-5 0V189h5m1-1h-7v5.5a3.5 3.5 0 007 0V188z",
    fill: "#e25950"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M510 189h5v4.5a2.5 2.5 0 01-2.5 2.5 2.5 2.5 0 01-2.5-2.5V189z",
    fill: "#555abf"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M512.5 196a2.5 2.5 0 01-2.5-2.5l1-.84.51.42.99-1.08 1 1.08.5-.41 1 .83a2.5 2.5 0 01-2.5 2.5z",
    fill: "#f6f9fc"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 511.5,
    cy: 190.04,
    r: 0.5,
    fill: "#f6f9fc"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 513.5,
    cy: 190.04,
    r: 0.5,
    fill: "#f6f9fc"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 512.49,
    cy: 191.17,
    r: 0.5,
    fill: "#f6f9fc"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M525 186a1 1 0 011 1v3h1v-3a2 2 0 00-2-2h-17a2 2 0 00-2 2v3h1v-3a1 1 0 011-1h17",
    fill: "#eaeef3"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M12 210a2 2 0 00-2 2v3h21v-3a2 2 0 00-2-2z",
    fill: "#f6f9fc"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#555abf",
    d: "M10 215h21v5H10z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M10 220v3a2 2 0 002 2h17a2 2 0 002-2v-3z",
    fill: "#e25950"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M13 213h7v5.5a3.5 3.5 0 01-3.5 3.5 3.5 3.5 0 01-3.5-3.5V213z",
    fill: "#f6f9fc"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M14 214h5v4.5a2.5 2.5 0 01-2.5 2.5 2.5 2.5 0 01-2.5-2.5V214z",
    fill: "#ed1c24"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 221a2.5 2.5 0 01-2.5-2.5h5a2.5 2.5 0 01-2.5 2.5z",
    fill: "#555abf"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M29 211a1 1 0 011 1v3h1v-3a2 2 0 00-2-2H12a2 2 0 00-2 2v3h1v-3a1 1 0 011-1h17",
    fill: "#eaeef3"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M16 214.5h1v4h-1z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M15 215h3v1h-3zm-.5 2h4v1h-4z"
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.995 210A1.997 1.997 0 0041 212.005V215h21v-2.995A2.006 2.006 0 0060.005 210z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41 215h21v5H41z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M41 220v2.995A2.006 2.006 0 0042.995 225h17.01A1.997 1.997 0 0062 222.995V220z",
    fill: "#217ab7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M41 215h1.001v5H41zm19.999 0H62v5h-1.001z"
  })))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 218v5a2 2 0 002 2h17a2 2 0 002-2v-5H72z",
    fill: "#217AB7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74 210a2 2 0 00-2 2v6h21v-6a2 2 0 00-2-2H74z",
    fill: "#F6F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 212a2 2 0 012-2h17a2 2 0 012 2v6h-1v-6a1 1 0 00-1-1H74a1 1 0 00-1 1v6h-1v-6z",
    fill: "#EAEEF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5 221a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
    fill: "#F4B32E"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.006 210a2 2 0 00-2.006 1.992v11.016a1.992 1.992 0 002.006 1.992H110v-15z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 210v15h4.994a2 2 0 002.006-1.992v-11.016a1.992 1.992 0 00-2.006-1.992z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-295",
    fill: "#fcd669",
    d: "M110 210h7v15h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.796 216.667l-1.458.003a.202.202 0 01-.193-.14l-.452-1.387a.202.202 0 00-.386 0l-.45 1.386a.202.202 0 01-.193.14h-1.46a.202.202 0 00-.118.368l1.18.857a.202.202 0 01.073.228l-.45 1.387a.202.202 0 00.313.227l1.18-.791a.202.202 0 01.238 0l1.18.791a.202.202 0 00.313-.227l-.452-1.387a.202.202 0 01.074-.228l1.18-.857a.202.202 0 00.075-.227.205.205 0 00-.194-.143z",
    fill: "#24b47e"
  })))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    ry: 2,
    fill: "#217ab7",
    x: 134,
    y: 210
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.633 216l-2.625.006a.364.364 0 01-.347-.253l-.813-2.497a.364.364 0 00-.695 0l-.811 2.496a.364.364 0 01-.347.253h-2.626a.364.364 0 00-.215.661l2.124 1.544a.364.364 0 01.132.409l-.81 2.497a.364.364 0 00.562.41l2.124-1.426a.364.364 0 01.43 0l2.125 1.425a.364.364 0 00.563-.409l-.813-2.497a.364.364 0 01.132-.41l2.125-1.543a.364.364 0 00.134-.409.37.37 0 00-.35-.257z",
    fill: "#fff"
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.995 210a1.997 1.997 0 00-1.995 2.005V215h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
    fill: "#555abf"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M165 215h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M165 215h1.001v5H165zm19.999 0H186v5h-1.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 220v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V220z",
    fill: "#555abf",
    "data-name": "Rectangle-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5 219a1.5 1.5 0 111.5-1.5 1.502 1.502 0 01-1.5 1.5zm0-2a.5.5 0 10.5.5.5.5 0 00-.5-.5z",
    fill: "#efcf57"
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.006 210a2 2 0 00-2.006 1.992v11.016a1.992 1.992 0 002.006 1.992H203v-15z",
    fill: "#43458b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 210v15h4.994a2 2 0 002.006-1.992v-11.016a1.992 1.992 0 00-2.006-1.992z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-295",
    fill: "#fcd669",
    d: "M203 210h7v15h-7z"
  })))), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M248 213h-21v-1a2 2 0 012-2h17a2 2 0 012 2z",
    fill: "#e25950"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M227 213h21v2h-21z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M227 213h1v2h-1z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M227 220h21v2h-21z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M227 222h21v1a2 2 0 01-2 2h-17a2 2 0 01-2-2z",
    fill: "#e25950"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "#555abf",
    d: "M227 215h21v5h-21z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M227 220h1v2h-1zm20-7h1v2h-1zm0 7h1v2h-1z"
  })), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.995 210a1.997 1.997 0 00-1.995 2.005V215h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
    fill: "#ca0814"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M258 215h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M258 220v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V220z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 218.5a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2-1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2-1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm-4 0a.5.5 0 11.5.5.5.5 0 01-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "path-174",
    d: "M264 218.5a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2-1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2-1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm-4 0a.5.5 0 11.5.5.5.5 0 01-.5-.5z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M258 215h1.001v5H258zm19.999 0H279v5h-1.001z"
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308 210h-17a1.99 1.99 0 00-1.438.615.813.813 0 01.205.116l.643.528L302 217.5l-11.59 6.241-.642.528a.813.813 0 01-.206.116A1.99 1.99 0 00291 225h17a2 2 0 002-2v-11a2 2 0 00-2-2z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd669",
    d: "M290.41 223.741L302 217.5l-11.59-6.241L298 217.5l-7.59 6.241z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.873 210.97l.537.289-.643-.528a.813.813 0 00-.206-.116 2.008 2.008 0 00-.238.301.623.623 0 01.55.054zm.537 12.771l-.537.289a.623.623 0 01-.55.054 1.998 1.998 0 00.239.3.813.813 0 00.205-.115z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.873 224.03l.537-.289L298 217.5l-7.59-6.241-.537-.289a.623.623 0 00-.55-.054A1.987 1.987 0 00289 212v11a1.986 1.986 0 00.323 1.084.623.623 0 00.55-.054zM292.5 216a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.5,
    cy: 217.5,
    r: 1.5,
    fill: "#f7fafc"
  })))), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322 210a2 2 0 00-2 2v11a2 2 0 002 2h17a2 2 0 002-2v-11a2 2 0 00-2-2h-17z",
    fill: "#E25950"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331 222a4 4 0 100-8 4 4 0 000 8zm1.334-6.31a2.333 2.333 0 100 4.62 2.667 2.667 0 110-4.62zM331 218a1.333 1.333 0 102.667 0 1.333 1.333 0 00-2.667 0z",
    fill: "#fff"
  })), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    ry: 2,
    fill: "#e25950",
    x: 351,
    y: 210
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.431 213.096a4.403 4.403 0 00-3.431 4.251 4.426 4.426 0 004.104 4.359 4.5 4.5 0 11-.673-8.61z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.5,
    cy: 217.5,
    r: 1.5,
    fill: "#fff"
  })))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f6f9fc",
    width: 21,
    height: 15,
    rx: 3,
    x: 382,
    y: 210
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "#e25950",
    d: "M401 210a2 2 0 012 2v8l-15-10zm-19 13a2 2 0 002 2h13l-15-10z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M384 210h1l18 12v1a2 2 0 01-2 2h-1l-18-12v-1a2 2 0 012-2z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    fill: "#e25950",
    x: 413,
    y: 210
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M415 210h7v9h-9v-7a2 2 0 012-2z",
    fill: "#555abf"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 417.5,
    cy: 214.5,
    r: 2.5,
    fill: "#fff"
  })), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcd669",
    d: "M450 225l15-10v-2l-18 12h3zm9-15l-15 10v2l18-12h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 210h-1.008a1.99 1.99 0 00-1.992 2v8l15-10z",
    fill: "#24b47e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 225h13.008a1.997 1.997 0 001.992-2v-8z",
    fill: "#45b2e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463 210h-1l-18 12v1a2 2 0 002 2h1l18-12v-1a2 2 0 00-2-2z"
  })))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.995 210a1.991 1.991 0 00-1.995 1.998V218h21v-6.002a2.002 2.002 0 00-1.995-1.998z",
    fill: "#45b2e8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-295",
    d: "M475 218v4.994a2.006 2.006 0 001.995 2.006h17.01a1.993 1.993 0 001.995-2.006V218z",
    fill: "#fcd669"
  })))), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M524.383 210h-15.766c-1.445 0-2.617 1.125-2.617 2.501h21c0-1.381-1.174-2.501-2.617-2.501zm2.617 7.5h-21v2.5h21v-2.5z",
    fill: "#333"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527 212.5h-21v2.5h21v-2.5zm0 7.5h-21v2.5h21V220z",
    fill: "#FCD669"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527 215h-21v2.5h21V215zm-2.617 10c1.445 0 2.617-1.11 2.617-2.5h-21c0 1.38 1.174 2.5 2.617 2.5h15.766z",
    fill: "#E25950"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.313 212.5H506v2.5h1.313v-2.5zm18.375 0v2.5H527v-2.5h-1.313zm0 10V220H527v2.5h-1.313zm-18.375-2.5H506v2.5h1.313V220z",
    fill: "#A68527",
    fillOpacity: 0.1
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.5 218.75c.725 0 1.313-.56 1.313-1.25s-.588-1.25-1.313-1.25-1.313.56-1.313 1.25.588 1.25 1.313 1.25z",
    fill: "#F7FAFC"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M29 250H12a2 2 0 01-2-2v-7h8v-6h11a2 2 0 012 2v11a2 2 0 01-2 2z",
    fill: "#e25950"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M10 246h21v1H10zm0-2h21v1H10zm0-2h21v1H10zm8-2h13v1H18zm0-2h13v1H18zm0-2h12.723a1.987 1.987 0 01.277 1H18zm12.723 13H10.277a1.986 1.986 0 01-.277-1h21a1.987 1.987 0 01-.277 1z",
    fill: "#f6f9fc"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M29 250H12a2 2 0 01-2-2v-7h1v7a1 1 0 001 1h17a1 1 0 001-1v-11a1 1 0 00-1-1H18v-1h11a2 2 0 012 2v11a2 2 0 01-2 2z",
    fill: "#e25950",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M10 242v-5a2 2 0 012-2h7v7z",
    fill: "#43458b"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M17.73 237.408a.703.703 0 11.676-.703.703.703 0 01-.676.703zm-.297 1.297a.704.704 0 11-.704-.705.704.704 0 01.704.704zm-1.703-1.297a.704.704 0 11.677-.704.704.704 0 01-.677.704zm-.297 1.297a.704.704 0 11-.704-.705.704.704 0 01.704.704zm-1.703-1.297a.704.704 0 11.677-.704.704.704 0 01-.677.704zm-.297 1.297a.704.704 0 11-.704-.705.704.704 0 01.704.704zm-1.703-1.297a.703.703 0 11.676-.703.703.703 0 01-.676.703zm0 2.592a.704.704 0 11-.678.703.704.704 0 01.678-.703zm2 0a.704.704 0 11-.678.703.704.704 0 01.678-.703zm2 0a.704.704 0 11-.678.703.704.704 0 01.678-.703zm2 0a.704.704 0 11-.678.703.704.704 0 01.678-.703z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M19 239.21a.703.703 0 110-1.011zm-9-.975a.697.697 0 011.219.47.703.703 0 01-.703.703.694.694 0 01-.516-.234z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }))), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M51 235h9a2 2 0 012 2v11H51v-13z",
    fill: "#f6f9fc"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "#012b7f",
    d: "M42 247h19v2H42z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M61 236.5h1v11h-1z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M43 235h8v12H41v-10a2 2 0 012-2z",
    fill: "#f6f9fc"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 239.5,
    r: 2.5,
    fill: "#fcd669"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "#012b7f",
    d: "M42 243.33h19v2H42zm8-3.66h11v2H50zm0-3.67h9.93a1.07 1.07 0 011.07 1.07v.93H50v-2z"
  })), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    fill: "#eaeef3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 238h1v10h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 236a1 1 0 011 1v3h1v-3a2 2 0 00-2-2H43a2 2 0 00-2 2v3h1v-3a1 1 0 011-1h17m0 13a1 1 0 001-1v-3h1v3a2 2 0 01-2 2H43a2 2 0 01-2-2v-3h1v3a1 1 0 001 1h17"
  }))), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.617 235h15.766c1.443 0 2.617 1.12 2.617 2.5v2.5H72v-2.5c0-1.39 1.172-2.5 2.617-2.5z",
    fill: "#217AB7"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.938 238.75c.724 0 1.312-.56 1.312-1.25s-.588-1.25-1.313-1.25c-.724 0-1.312.56-1.312 1.25s.588 1.25 1.313 1.25z",
    fill: "#fff"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M72 240h21v5H72v-5z",
    fill: "#F6F9FC"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.313 240H72v5h1.313v-5zm18.375 0v5H93v-5h-1.313z",
    fill: "#EAEEF3"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 245h21v2.5c0 1.39-1.172 2.5-2.617 2.5H74.617c-1.443 0-2.617-1.12-2.617-2.5V245z",
    fill: "#24B47E"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "#E25950",
    d: "M72 240h21v1.25H72zm0 3.75h21V245H72z"
  })), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.995 235a1.997 1.997 0 00-1.995 2.005V240h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
    fill: "#fcd669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 245v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V245z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43458b",
    d: "M103 240h21v6h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 244.5a.5.5 0 11.5.5.5.5 0 01-.5-.5zm1-2a.5.5 0 11.5.5.5.5 0 01-.5-.5zm3-1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm3 1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm1 2a.5.5 0 11.5.5.5.5 0 01-.5-.5z",
    fill: "#fff"
  })))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 2,
    ry: 2,
    fill: "#e25950",
    x: 134,
    y: 235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.633 241l-2.625.006a.364.364 0 01-.347-.253l-.813-2.497a.364.364 0 00-.695 0l-.811 2.496a.364.364 0 01-.347.253h-2.626a.364.364 0 00-.215.661l2.124 1.544a.364.364 0 01.132.409l-.81 2.497a.364.364 0 00.562.41l2.124-1.426a.364.364 0 01.43 0l2.125 1.425a.364.364 0 00.563-.409l-.813-2.497a.364.364 0 01.132-.41l2.125-1.543a.364.364 0 00.134-.409.37.37 0 00-.35-.257z",
    fill: "#fcd669"
  })))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184 250h-11.098l8.66-15H184a2 2 0 012 2v11a2 2 0 01-2 2zm-14.562 0H167a2 2 0 01-2-2v-11a2 2 0 012-2h11.098z",
    "data-name": "Layer 1"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.995 235a1.997 1.997 0 00-1.995 2.005V240h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
    fill: "#e25950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M196 240h21v5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-34",
    d: "M196 245v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaeef3",
    d: "M196 240h1.001v5H196zm19.999 0H217v5h-1.001z"
  })))), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f9fc",
    d: "M230 235h18v15h-18z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M237.24 239.25H248V237a2 2 0 00-2-2h-14.71z",
    fill: "#e25950"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M231.29 250H246a2 2 0 002-2v-2.25h-10.76z",
    fill: "#012b7f"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M248 245h-11l-7 5h-1a2 2 0 01-2-2v-11a2 2 0 012-2h1l7 5h11z",
    fill: "#24b47e"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M227 247v-9l6.5 4.5-6.5 4.5z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd669",
    d: "M227.43 237.38l-.43-.29v.91l6.5 4.5-6.5 4.5v.91l.43-.29 6.5-4.5.89-.62-.89-.62-6.5-4.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcons);
export default __webpack_public_path__ + "static/media/flagIcons.6db8188a7f2e69aece3be739610cd71b.svg";
export { ForwardRef as ReactComponent };